(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-seal-divider-nusswahn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-seal-divider')) {
    customElements.define(
      'brand-seal-divider',
      class extends HTMLElement {
        connectedCallback() {
          this.seal = this.querySelector('.brand-seal-divider__seal');
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.abortController?.abort();
          this.abortController = new AbortController();
          const { signal } = this.abortController;
          this.update = () => {
            if (!this.seal || this.motionQuery.matches) return;
            const distance = window.scrollY + window.innerHeight * 0.5 - this.offsetTop;
            this.seal.style.setProperty('--seal-rotation', `${distance * 0.08}deg`);
          };
          window.addEventListener('scroll', this.update, { passive: true, signal });
          window.addEventListener('resize', this.update, { passive: true, signal });
          this.motionQuery.addEventListener('change', this.update, { signal });
          this.update();
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nusswahn-collection-reviews')) {
    customElements.define(
      'nusswahn-collection-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.markAnonymous = this.markAnonymous.bind(this);
          this.observer = new MutationObserver(this.markAnonymous);
          this.observer.observe(this, { childList: true, subtree: true });
          this.markAnonymous();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        markAnonymous() {
          const platzhalter = ['anonymous', 'anonym'];
          this.querySelectorAll('.jdgm-carousel-item__reviewer-name').forEach((name) => {
            const text = name.textContent.trim().toLowerCase();
            name.classList.toggle('is-anonymous', platzhalter.includes(text));
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /*
   * Gemeinsamer Formularzustand für Newsletter, Kontakt und die beiden B2B-Anfragen.
   * Aufgaben: Erfolgs-/Fehlermeldung nach dem Laden in eine echte Live-Region schreiben,
   * beim Absenden einen kurzen Busy-Zustand zeigen und Doppelabsendungen verhindern.
   */
  if (!customElements.get('nw-form-status')) {
    class NwFormStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.timers = [];
        this.busy = false;
        this.form = this.querySelector('form');
        this.announcer = this.querySelector('[data-form-announcer]');
        this.submitButton = this.querySelector('[data-form-submit]');

        this.onSubmit = this.handleSubmit.bind(this);
        this.onPageShow = this.handlePageShow.bind(this);

        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);

        this.announceRenderedMessage();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
        this.clearTimers();
        this.dataset.initialized = 'false';
      }

      clearTimers() {
        (this.timers || []).forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      defer(callback, delay) {
        this.timers.push(window.setTimeout(callback, delay));
      }

      /*
       * Eine Live-Region kündigt Inhalte, die bereits beim Seitenaufbau darin stehen,
       * nicht an. Der sichtbare Text bleibt deshalb statisch und wird kurz nach dem
       * Laden zusätzlich in die leere Live-Region geschrieben.
       */
      announce(message, autoClear) {
        if (!this.announcer || !message) return;
        this.announcer.textContent = '';
        this.defer(() => {
          this.announcer.textContent = message;
        }, 160);
        if (autoClear) {
          this.defer(() => {
            this.announcer.textContent = '';
          }, 6000);
        }
      }

      announceRenderedMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message) return;
        this.announce(message.textContent.replace(/\s+/g, ' ').trim(), true);
      }

      handleSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }
        this.busy = true;
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) timeoutHint.hidden = true;
        this.announce(this.dataset.sendingMessage, false);
        if (!this.submitButton) return;
        this.submitButton.classList.add('is-busy');
        this.submitButton.setAttribute('aria-busy', 'true');
        // Erst nach dem Absenden sperren, damit der Request vollständig abgeht.
        this.defer(() => {
          this.submitButton.disabled = true;
        }, 0);
        this.watchSubmission();
      }

      /*
       * Shopify schickt das Formular erst ab, wenn hCaptcha ein Token geliefert hat, und
       * lädt dann die Seite neu. Bleibt beides aus (Captcha-Skript blockiert, Challenge
       * weggeklickt, Netzwerkfehler), zeigte der Button sonst endlos „Wird gesendet“
       * (Kundenmeldung 16. September 2026, Chrome unter Windows). Solange eine sichtbare
       * Challenge offen ist, warten wir; sonst gibt ein Timeout den Button wieder frei und
       * zeigt den Hinweis aus [data-form-timeout] beziehungsweise data-timeout-message.
       */
      watchSubmission() {
        const limit = Number(this.dataset.submitTimeout) || 15000;
        const graceAfterChallenge = 4000;
        let deadline = Date.now() + limit;
        const tick = () => {
          if (!this.busy) return;
          if (this.hasOpenChallenge()) {
            deadline = Date.now() + graceAfterChallenge;
          } else if (Date.now() >= deadline) {
            this.releaseSubmit();
            return;
          }
          this.defer(tick, 500);
        };
        this.defer(tick, 500);
      }

      hasOpenChallenge() {
        return [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((frame) => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
        });
      }

      releaseSubmit() {
        this.busy = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-busy');
          this.submitButton.removeAttribute('aria-busy');
        }
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) {
          timeoutHint.hidden = false;
          this.announce(timeoutHint.textContent.replace(/\s+/g, ' ').trim(), false);
        } else if (this.dataset.timeoutMessage) {
          this.announce(this.dataset.timeoutMessage, false);
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.clearTimers();
        this.busy = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('is-busy');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    customElements.define('nw-form-status', NwFormStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-nusswahn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-products-slider')) {
    class FeaturedProductsSlider extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.featured-products__rail');
        if (!this.rail) return;

        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.scrollEndTimer);
        clearTimeout(this.resizeTimer);
        this.removeLoopClones();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.nextButton = this.querySelector('[data-featured-next]');
        this.originalCards = [
          ...this.rail.querySelectorAll(':scope > .product-card:not([data-loop-clone])'),
        ];
        this.autoplayRequested = this.dataset.autoplay === 'true';
        this.autoplayDelay = Math.max(2800, Number(this.dataset.autoplayDelay) || 4000);
        this.interactionReasons = new Set();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.setAttribute('data-enhanced', '');
        this.setupLoop();

        this.rail.addEventListener(
          'scroll',
          () => {
            this.scheduleUpdate();
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = window.setTimeout(() => this.handleScrollEnd(), 140);
          },
          { passive: true, signal },
        );
        this.nextButton?.addEventListener('click', () => this.advance(), { signal });
        this.addEventListener('mouseenter', () => this.pauseFor('hover'), { signal });
        this.addEventListener('mouseleave', () => this.resumeFor('hover'), { signal });
        this.rail.addEventListener('pointerdown', () => this.pauseFor('pointer'), { signal });
        window.addEventListener('pointerup', () => this.resumeFor('pointer'), { signal });
        window.addEventListener('pointercancel', () => this.resumeFor('pointer'), { signal });
        this.addEventListener(
          'focusin',
          () => this.pauseFor('focus'),
          { signal },
        );
        this.addEventListener(
          'focusout',
          (event) => {
            if (!this.contains(event.relatedTarget)) this.resumeFor('focus');
          },
          { signal },
        );
        document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), { signal });
        this.motionQuery.addEventListener('change', () => this.scheduleUpdate(), { signal });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => this.refreshLoopMetrics(true), 100);
          });
          this.resizeObserver.observe(this.rail);
        }

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.scrollEndTimer);
        clearTimeout(this.resizeTimer);
        this.removeLoopClones();
      }

      setupLoop() {
        this.originalCards.forEach((card, index) => {
          card.dataset.loopIndex = String(index);
          card.toggleAttribute('data-loop-first', index === 0);
        });

        this.loopEnabled = this.originalCards.length > 1;
        if (!this.loopEnabled) {
          this.cards = this.originalCards;
          return;
        }

        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        this.originalCards.forEach((card, index) => {
          before.append(this.createLoopClone(card, index));
          after.append(this.createLoopClone(card, index));
        });

        this.rail.prepend(before);
        this.rail.append(after);
        this.rail.setAttribute('data-loop-ready', '');
        this.cards = [...this.rail.querySelectorAll(':scope > .product-card')];

        requestAnimationFrame(() => {
          this.refreshLoopMetrics(false);
          this.rail.scrollTo({ left: this.loopStart, behavior: 'auto' });
          this.scheduleUpdate();
        });
      }

      createLoopClone(card, index) {
        const clone = card.cloneNode(true);
        clone.dataset.loopClone = '';
        clone.dataset.loopIndex = String(index);
        clone.toggleAttribute('data-loop-first', index === 0);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone
          .querySelectorAll('[for], [aria-controls], [aria-describedby], [aria-labelledby]')
          .forEach((element) => {
            element.removeAttribute('for');
            element.removeAttribute('aria-controls');
            element.removeAttribute('aria-describedby');
            element.removeAttribute('aria-labelledby');
          });
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      removeLoopClones() {
        if (!this.rail) return;
        this.rail.querySelectorAll(':scope > [data-loop-clone]').forEach((clone) => clone.remove());
        this.rail.querySelectorAll(':scope > .product-card').forEach((card) => {
          card.removeAttribute('data-loop-index');
          card.removeAttribute('data-loop-first');
          card.classList.remove('is-featured');
        });
        this.rail.removeAttribute('data-loop-ready');
      }

      refreshLoopMetrics(preserveProduct) {
        if (!this.loopEnabled) {
          this.scheduleUpdate();
          return;
        }

        let productIndex = 0;
        if (preserveProduct) {
          const featured = this.cards.find((card) => card.classList.contains('is-featured'));
          productIndex = Number(featured?.dataset.loopIndex) || 0;
        }

        const firstOriginal = this.originalCards[0];
        const firstAfter = this.rail.querySelector(
          ':scope > [data-loop-clone]:nth-last-child(' + this.originalCards.length + ')',
        );
        this.loopStart = this.getCardScrollLeft(firstOriginal);
        this.loopEnd = this.getCardScrollLeft(firstAfter);
        this.loopWidth = this.loopEnd - this.loopStart;

        if (preserveProduct) {
          const target = this.originalCards[productIndex] || firstOriginal;
          this.rail.scrollTo({
            left: this.getCardScrollLeft(target),
            behavior: 'auto',
          });
        }

        this.scheduleUpdate();
      }

      usesCenteredCards() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      getCardScrollLeft(card) {
        const cardStart = card.offsetLeft - this.rail.offsetLeft;
        if (!this.usesCenteredCards()) return cardStart;

        return Math.max(0, cardStart - (this.rail.clientWidth - card.offsetWidth) / 2);
      }

      handleScrollEnd() {
        if (!this.loopEnabled || !this.loopWidth) return;
        const currentScroll = this.rail.scrollLeft;
        let normalizedScroll = currentScroll;

        if (currentScroll >= this.loopEnd - 2) {
          normalizedScroll = currentScroll - this.loopWidth;
        } else if (currentScroll < this.loopStart - 2) {
          normalizedScroll = currentScroll + this.loopWidth;
        }

        if (Math.abs(normalizedScroll - currentScroll) > 1) {
          this.rail.scrollTo({ left: normalizedScroll, behavior: 'auto' });
        }

        this.scheduleUpdate();
      }

      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          const maximumScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
          const currentScroll = Math.max(0, this.rail.scrollLeft);
          const threshold = 2;

          this.toggleAttribute('data-can-scroll-back', currentScroll > threshold);
          this.toggleAttribute('data-can-scroll-forward', currentScroll < maximumScroll - threshold);
          this.updateFeaturedCard();
          this.autoplayAvailable =
            this.autoplayRequested && this.loopEnabled && !this.motionQuery.matches;
          this.scheduleAutoplay();
        });
      }

      updateFeaturedCard() {
        if (this.cards.length === 0) return;
        const railBounds = this.rail.getBoundingClientRect();
        const isCentered = this.usesCenteredCards();
        const referencePoint = isCentered ? railBounds.left + railBounds.width / 2 : railBounds.left;
        let featuredCard = this.cards[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        this.cards.forEach((card) => {
          const cardBounds = card.getBoundingClientRect();
          const cardPoint = isCentered ? cardBounds.left + cardBounds.width / 2 : cardBounds.left;
          const distance = Math.abs(cardPoint - referencePoint);
          if (distance < closestDistance) {
            featuredCard = card;
            closestDistance = distance;
          }
        });

        this.cards.forEach((card) => card.classList.toggle('is-featured', card === featuredCard));
      }

      pauseFor(reason) {
        this.interactionReasons.add(reason);
        this.scheduleAutoplay();
      }

      resumeFor(reason) {
        this.interactionReasons.delete(reason);
        this.scheduleAutoplay();
      }

      scheduleAutoplay() {
        clearTimeout(this.autoplayTimer);
        if (
          !this.autoplayAvailable ||
          this.interactionReasons.size > 0 ||
          document.hidden
        ) {
          return;
        }

        this.autoplayTimer = window.setTimeout(() => {
          this.advance();
          this.scheduleAutoplay();
        }, this.autoplayDelay);
      }

      advance() {
        const currentScroll = Math.max(0, this.rail.scrollLeft);
        const nextCard = this.cards.find(
          (card) => this.getCardScrollLeft(card) > currentScroll + 4,
        );
        if (!nextCard) return;

        this.rail.scrollTo({
          left: this.getCardScrollLeft(nextCard),
          behavior: this.motionQuery.matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('featured-products-slider', FeaturedProductsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-search-status]');
      this.controller = null;
      this.enterTimer = null;
      this.handleInput = () => this.search();
      this.input?.addEventListener('input', this.handleInput);
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.handleInput);
      this.controller?.abort();
      window.clearTimeout(this.enterTimer);
    }

    reset() {
      this.results.replaceChildren();
      this.results.removeAttribute('aria-busy');
      if (this.status) this.status.textContent = '';
    }

    // Drei ruhige Platzhalterzeilen in der Geometrie einer echten Ergebniszeile.
    // Ohne innerHTML, damit der Locale-Text nicht als Markup interpretiert wird.
    showPlaceholders() {
      if (this.status) this.status.textContent = window.nusswahnSearchLoading || '';

      const placeholders = document.createElement('ul');
      placeholders.className = 'predictive-search__skeleton';
      placeholders.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < 3; index += 1) {
        const row = document.createElement('li');
        const media = document.createElement('div');
        const lines = document.createElement('div');
        lines.append(document.createElement('div'), document.createElement('div'));
        row.append(media, lines);
        placeholders.append(row);
      }

      this.results.setAttribute('aria-busy', 'true');
      this.results.replaceChildren(placeholders);
    }

    revealResults() {
      window.clearTimeout(this.enterTimer);
      this.results.classList.remove('is-entering');
      requestAnimationFrame(() => this.results.classList.add('is-entering'));
      this.enterTimer = window.setTimeout(() => this.results.classList.remove('is-entering'), 320);
    }

    async search() {
      const term = this.input.value.trim();
      this.controller?.abort();
      if (term.length < 2) {
        this.reset();
        return;
      }
      this.controller = new AbortController();
      this.showPlaceholders();
      const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(term)}&section_id=predictive-search`;
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        this.results.removeAttribute('aria-busy');
        if (this.status) this.status.textContent = '';
        this.results.innerHTML = documentFragment.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        this.revealResults();
      } catch (error) {
        if (error.name !== 'AbortError') this.reset();
      }
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);

  class NavFeatureLabel extends HTMLElement {
    connectedCallback() {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopQuery = window.matchMedia('(min-width: 900px)');
      this.mobileMenu = this.closest('[data-mobile-menu]');
      this.cycleTimer = null;
      this.animationFallbackTimer = null;
      this.frameId = null;
      this.handleContextChange = () => this.restart();
      this.handleAnimationEnd = (event) => {
        if (event.animationName !== 'nav-feature-float' || event.pseudoElement) return;
        this.finishAnimation();
      };

      this.addEventListener('animationend', this.handleAnimationEnd);
      this.motionQuery.addEventListener('change', this.handleContextChange);
      this.desktopQuery.addEventListener('change', this.handleContextChange);
      this.mobileMenu?.addEventListener('toggle', this.handleContextChange);
      document.addEventListener('visibilitychange', this.handleContextChange);
      this.restart();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('animationend', this.handleAnimationEnd);
      this.motionQuery?.removeEventListener('change', this.handleContextChange);
      this.desktopQuery?.removeEventListener('change', this.handleContextChange);
      this.mobileMenu?.removeEventListener('toggle', this.handleContextChange);
      document.removeEventListener('visibilitychange', this.handleContextChange);
    }

    isEligible() {
      const isDesktopLabel = !this.mobileMenu;
      const isCorrectViewport = isDesktopLabel ? this.desktopQuery.matches : !this.desktopQuery.matches;
      const isMobileMenuVisible = !this.mobileMenu || (this.mobileMenu.open && !this.mobileMenu.classList.contains('is-closing'));
      return (
        !this.motionQuery.matches &&
        document.visibilityState === 'visible' &&
        isCorrectViewport &&
        isMobileMenuVisible &&
        this.getClientRects().length > 0
      );
    }

    randomDelay() {
      return 3000 + Math.round(Math.random() * 3000);
    }

    restart() {
      this.stop();
      this.schedule(300);
    }

    schedule(delay) {
      if (!this.isEligible()) return;
      window.clearTimeout(this.cycleTimer);
      this.cycleTimer = window.setTimeout(() => this.play(), delay);
    }

    play() {
      this.cycleTimer = null;
      if (!this.isEligible()) return;
      this.frameId = requestAnimationFrame(() => {
        this.frameId = null;
        if (!this.isEligible()) return;
        this.classList.add('is-animating');
        this.animationFallbackTimer = window.setTimeout(() => this.finishAnimation(), 700);
      });
    }

    finishAnimation() {
      if (!this.classList.contains('is-animating')) return;
      window.clearTimeout(this.animationFallbackTimer);
      this.animationFallbackTimer = null;
      this.classList.remove('is-animating');
      this.schedule(this.randomDelay());
    }

    stop() {
      window.clearTimeout(this.cycleTimer);
      window.clearTimeout(this.animationFallbackTimer);
      if (this.frameId !== null) cancelAnimationFrame(this.frameId);
      this.cycleTimer = null;
      this.animationFallbackTimer = null;
      this.frameId = null;
      this.classList.remove('is-animating');
    }
  }

  if (!customElements.get('nav-feature-label')) customElements.define('nav-feature-label', NavFeatureLabel);

  const siteHeader = document.querySelector('.site-header');
  const updateHeaderState = () => siteHeader?.classList.toggle('site-header--scrolled', window.scrollY > 24);
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  const searchDialog = document.querySelector('[data-search-dialog]');
  const cartDialog = document.querySelector('[data-cart-dialog]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuSummary = mobileMenu?.querySelector(':scope > summary');
  const mobileMenuPanel = mobileMenu?.querySelector('.mobile-menu__panel');
  const mobileMenuCloseButton = mobileMenuPanel?.querySelector('[data-mobile-menu-close]');
  const cartSectionId = cartDialog?.dataset.cartSectionId;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let cartCloseTimer;
  let searchCloseTimer;
  let mobileMenuCloseTimer;
  let cartIsUpdating = false;

  // Überlebt den Austausch des Drawer-Inhalts. Nur so lässt sich der echte Übergang
  // von "nicht erreicht" auf "erreicht" von einem bereits vollen Warenkorb unterscheiden.
  let lastShippingProgress = Number(
    cartDialog?.querySelector('[data-shipping-progress]')?.dataset.progressValue || 0,
  );

  const finishMobileMenuClose = () => {
    if (!mobileMenu) return;
    mobileMenu.open = false;
    mobileMenu.classList.remove('is-closing');
    mobileMenuSummary?.focus();
  };

  const closeMobileMenu = () => {
    if (!mobileMenu?.open) return;
    window.clearTimeout(mobileMenuCloseTimer);
    mobileMenu.classList.add('is-closing');
    if (reducedMotion.matches) finishMobileMenuClose();
    else mobileMenuCloseTimer = window.setTimeout(finishMobileMenuClose, 340);
  };

  // Sichtbarkeit hängt am nativen [open]; das JS ergänzt nur Fokus und Schließ-Animation.
  const syncMobileMenuOpenState = () => {
    if (!mobileMenu?.open) return;
    window.clearTimeout(mobileMenuCloseTimer);
    mobileMenu.classList.remove('is-closing');
    mobileMenuCloseButton?.focus();
  };

  mobileMenu?.addEventListener('toggle', () => {
    if (!mobileMenu.open) {
      mobileMenu.classList.remove('is-closing');
      return;
    }
    syncMobileMenuOpenState();
  });

  // Das Menü kann bereits offen sein, wenn dieses Skript erst danach lädt.
  syncMobileMenuOpenState();

  mobileMenuSummary?.addEventListener('click', (event) => {
    if (!mobileMenu.open) return;
    event.preventDefault();
    closeMobileMenu();
  });

  mobileMenu?.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', closeMobileMenu);
  });

  mobileMenuPanel?.querySelectorAll('a[href]').forEach((link) => {
    link.addEventListener('click', closeMobileMenu);
  });

  document.addEventListener('keydown', (event) => {
    if (!mobileMenu?.open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMobileMenu();
      return;
    }
    if (event.key !== 'Tab' || !mobileMenuPanel) return;

    const focusableElements = [
      ...mobileMenuPanel.querySelectorAll(
        'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ].filter((element) => !element.hidden && element.getClientRects().length > 0);
    if (focusableElements.length === 0) {
      event.preventDefault();
      mobileMenuPanel.focus();
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    if (event.shiftKey && (document.activeElement === firstFocusable || document.activeElement === mobileMenuPanel)) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    } else if (!mobileMenuPanel.contains(document.activeElement)) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  // Der Suchdialog verwendet dasselbe is-open-Muster wie der Cart Drawer.
  const openSearchDialog = () => {
    if (!searchDialog) return;
    window.clearTimeout(searchCloseTimer);
    searchDialog.classList.remove('is-closing');
    if (!searchDialog.open) searchDialog.showModal();
    // iOS öffnet die Tastatur nur bei synchronem Fokus in der Nutzergeste.
    searchDialog.querySelector('#HeaderSearch')?.focus({ preventScroll: true });
    requestAnimationFrame(() => searchDialog.classList.add('is-open'));
  };

  const closeSearchDialog = () => {
    if (!searchDialog?.open) return;
    const finish = () => {
      searchDialog.close();
      searchDialog.classList.remove('is-closing');
    };
    searchDialog.classList.remove('is-open');
    searchDialog.classList.add('is-closing');
    window.clearTimeout(searchCloseTimer);
    if (reducedMotion.matches) finish();
    else searchCloseTimer = window.setTimeout(finish, 360);
  };

  document.querySelector('[data-search-open]')?.addEventListener('click', openSearchDialog);
  searchDialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeSearchDialog();
  });
  document.querySelectorAll('[data-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = button.closest('dialog');
      if (dialog === cartDialog) closeCartDrawer();
      else if (dialog === searchDialog) closeSearchDialog();
      else dialog?.close();
    });
  });
  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      if (dialog === cartDialog) closeCartDrawer();
      else if (dialog === searchDialog) closeSearchDialog();
      else dialog.close();
    });
  });

  const animateCartCounts = (className, duration) => {
    document.querySelectorAll('[data-cart-count], [data-cart-heading-count]').forEach((count) => {
      count.classList.remove('is-bumping', 'is-entering');
      requestAnimationFrame(() => count.classList.add(className));
      window.setTimeout(() => count.classList.remove(className), duration);
    });
  };

  // Nur echte Erhöhungen bewegen die Zahl: 0 -> n blendet ruhig ein, n -> mehr bumpt.
  const bumpCartCounts = () => animateCartCounts('is-bumping', 450);
  const revealCartCounts = () => animateCartCounts('is-entering', 340);

  const readCartCount = () => {
    const source =
      document.querySelector('[data-cart-count]') || document.querySelector('[data-cart-heading-count]');
    return Number(source?.textContent.trim() || 0);
  };

  const cartStatus = cartDialog?.querySelector('[data-cart-status]');

  /*
   * Die Statuszeile wird ausschließlich im Fehlerfall sichtbar. Jede bestätigende Meldung
   * bleibt für Screenreader erhalten, taucht aber nicht als Textbanner über dem Warenkorb auf -
   * den Erfolg zeigt die Oberfläche selbst (verschwundene Zeile, Sheen, Summen).
   */
  const setCartStatus = (message = '', tone = 'error') => {
    if (!cartStatus) return;
    const isError = message !== '' && tone === 'error';
    cartStatus.textContent = message;
    cartStatus.classList.toggle('is-error', isError);
    cartStatus.classList.toggle('is-quiet', message !== '' && !isError);
  };

  const findCartLine = (key) =>
    [...(cartDialog?.querySelectorAll('[data-cart-line]') || [])].find(
      (candidate) => candidate.dataset.cartLineKey === key,
    );

  const readCartLineQuantity = (key) => {
    const input = findCartLine(key)?.querySelector('[data-cart-quantity-input]');
    return input ? Number.parseInt(input.value, 10) || 0 : 0;
  };

  const readCartLineTitle = (line) =>
    line?.querySelector('.cart-drawer__item-title')?.textContent.trim() || '';

  // Gegenstück zu is-just-added: erst die Zeile ruhig ausblenden, dann austauschen.
  // Bei reduzierter Bewegung entfällt der Übergang und der Austausch erfolgt sofort.
  const collapseCartLine = (key) => {
    const line = findCartLine(key);
    if (!line || reducedMotion.matches) return null;
    line.style.setProperty('--cart-line-height', `${line.getBoundingClientRect().height}px`);
    line.classList.add('is-removing');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => line.classList.add('is-removed'));
    });
    return new Promise((resolve) => window.setTimeout(resolve, 260));
  };

  const applyCartSection = (sectionHtml, { addedKey, progressFrom } = {}) => {
    if (!cartDialog || !sectionHtml) return null;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextContent = parsed.querySelector('[data-cart-content]');
    if (!nextContent) return null;

    const previousCount = readCartCount();
    const currentProgress = cartDialog.querySelector('[data-shipping-progress]');
    const previousProgress = Number(progressFrom ?? currentProgress?.dataset.progressValue ?? 0);
    cartDialog.querySelector('[data-cart-content]')?.replaceWith(nextContent);
    const nextProgress = nextContent.querySelector('[data-shipping-progress]');
    const nextShipping = Number(nextProgress?.dataset.progressValue || 0);
    const shippingJustReached = lastShippingProgress < 100 && nextShipping >= 100;
    lastShippingProgress = nextShipping;
    if (nextProgress && !reducedMotion.matches) {
      nextProgress.style.setProperty('--shipping-progress', `${previousProgress}%`);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => nextProgress.style.setProperty('--shipping-progress', `${nextShipping}%`));
      });
    }
    if (shippingJustReached) {
      const shippingBox = nextContent.querySelector('.cart-drawer__shipping');
      if (shippingBox && !reducedMotion.matches) {
        shippingBox.classList.add('is-just-reached');
        window.setTimeout(() => shippingBox.classList.remove('is-just-reached'), 700);
      }
      setCartStatus(window.nusswahnCartShippingReached || '', 'quiet');
    }
    const nextHeaderCount = parsed.querySelector('[data-cart-heading-count]');
    const itemCount = Number(nextHeaderCount?.textContent.trim() || 0);
    document.querySelectorAll('[data-cart-count], [data-cart-heading-count]').forEach((count) => {
      count.textContent = itemCount;
      count.hidden = itemCount === 0;
    });

    if (addedKey) {
      const addedLine = [...cartDialog.querySelectorAll('[data-cart-line]')].find(
        (line) => line.dataset.cartLineKey === addedKey,
      );
      addedLine?.classList.add('is-just-added');
      window.setTimeout(() => addedLine?.classList.remove('is-just-added'), 720);
    }

    if (itemCount > previousCount) {
      if (previousCount === 0) revealCartCounts();
      else bumpCartCounts();
    }
    return { shippingJustReached };
  };

  const renderCartDrawer = async (options = {}) => {
    if (!cartDialog || !cartSectionId) return;
    const content = cartDialog.querySelector('[data-cart-content]');
    content?.classList.add('is-updating');
    content?.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('section_id', cartSectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Cart section request failed: ${response.status}`);
      applyCartSection(await response.text(), options);
    } catch (error) {
      console.error(error);
    } finally {
      cartDialog.querySelector('[data-cart-content]')?.classList.remove('is-updating');
      cartDialog.querySelector('[data-cart-content]')?.removeAttribute('aria-busy');
    }
  };

  const openCartDrawer = ({ sectionHtml, addedKey } = {}) => {
    if (!cartDialog) return;
    setCartStatus();
    window.clearTimeout(cartCloseTimer);
    cartDialog.classList.remove('is-closing');
    if (!cartDialog.open) {
      cartDialog.showModal();
    }
    requestAnimationFrame(() => cartDialog.classList.add('is-open'));
    if (sectionHtml && applyCartSection(sectionHtml, { addedKey, progressFrom: 0 })) return;
    renderCartDrawer({ addedKey, progressFrom: 0 });
  };

  const closeCartDrawer = () => {
    if (!cartDialog?.open) return;
    const finish = () => {
      cartDialog.close();
      cartDialog.classList.remove('is-closing');
    };
    cartDialog.classList.remove('is-open');
    cartDialog.classList.add('is-closing');
    window.clearTimeout(cartCloseTimer);
    if (reducedMotion.matches) finish();
    else cartCloseTimer = window.setTimeout(finish, 360);
  };

  document.querySelector('[data-cart-open]')?.addEventListener('click', () => openCartDrawer());
  cartDialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeCartDrawer();
  });

  const changeCartLine = async (key, quantity, { removedTitle } = {}) => {
    if (!cartDialog || !cartSectionId || cartIsUpdating) return;
    const content = cartDialog.querySelector('[data-cart-content]');
    cartIsUpdating = true;
    content?.classList.add('is-updating');
    content?.setAttribute('aria-busy', 'true');
    // Läuft parallel zur Anfrage; der Austausch wartet danach auf beides.
    const lineExit = quantity === 0 ? collapseCartLine(key) : null;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: cartSectionId,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      if (lineExit) await lineExit;
      const applied = applyCartSection(result.sections?.[cartSectionId]);
      if (!applied) await renderCartDrawer();
      if (removedTitle) {
        setCartStatus(
          (window.nusswahnCartRemoved || '').replace('__PRODUCT__', () => removedTitle),
          'quiet',
        );
      } else if (!applied?.shippingJustReached) {
        setCartStatus();
      }
    } catch (error) {
      // Die englische API-Rohmeldung bleibt in der Konsole, die UI bekommt Locale-Text.
      console.error(error);
      await renderCartDrawer();
      const availableQuantity = readCartLineQuantity(key);
      if (quantity > 0 && availableQuantity > 0 && availableQuantity < quantity) {
        setCartStatus(window.nusswahnCartQuantityLimit.replace('__QUANTITY__', availableQuantity));
      } else {
        setCartStatus(window.nusswahnCartUpdateError);
      }
    } finally {
      cartIsUpdating = false;
      cartDialog.querySelector('[data-cart-content]')?.classList.remove('is-updating');
      cartDialog.querySelector('[data-cart-content]')?.removeAttribute('aria-busy');
    }
  };

  cartDialog?.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-cart-quantity]');
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!quantityButton && !removeButton) return;
    const line = event.target.closest('[data-cart-line]');
    if (!line) return;

    if (removeButton) {
      changeCartLine(line.dataset.cartLineKey, 0, { removedTitle: readCartLineTitle(line) });
      return;
    }

    const input = line.querySelector('[data-cart-quantity-input]');
    const direction = quantityButton.dataset.cartQuantity;
    const nextQuantity = Math.max(0, Number(input.value) + (direction === 'increase' ? 1 : -1));
    changeCartLine(line.dataset.cartLineKey, nextQuantity, {
      removedTitle: nextQuantity === 0 ? readCartLineTitle(line) : '',
    });
  });

  cartDialog?.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-quantity-input]')) return;
    const line = event.target.closest('[data-cart-line]');
    const quantity = Math.max(0, Number.parseInt(event.target.value, 10) || 0);
    if (line) {
      changeCartLine(line.dataset.cartLineKey, quantity, {
        removedTitle: quantity === 0 ? readCartLineTitle(line) : '',
      });
    }
  });

  cartDialog?.addEventListener('submit', async (event) => {
    const discountForm = event.target.closest('[data-cart-discount-form]');
    if (discountForm) {
      event.preventDefault();
      const button = discountForm.querySelector('button[type="submit"]');
      const input = discountForm.querySelector('[name="discount"]');
      const status = discountForm.querySelector('[data-cart-discount-status]');
      const discountCode = input.value.trim();
      if (!discountCode) return;
      button.disabled = true;
      input.removeAttribute('aria-invalid');
      status.textContent = '';
      status.classList.remove('is-error');
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: discountCode,
            sections: cartSectionId,
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        const returnedCode = result.discount_codes?.find(
          (discount) => discount.code.toLowerCase() === discountCode.toLowerCase(),
        );
        if (returnedCode?.applicable === false) {
          input.setAttribute('aria-invalid', 'true');
          status.textContent = window.nusswahnDiscountInvalid;
          status.classList.add('is-error');
          return;
        }
        const sectionApplied = applyCartSection(result.sections?.[cartSectionId]);
        if (!sectionApplied) await renderCartDrawer();
        const nextForm = cartDialog.querySelector('[data-cart-discount-form]');
        const nextDetails = nextForm?.closest('details');
        const nextStatus = nextForm?.querySelector('[data-cart-discount-status]');
        if (nextDetails) nextDetails.open = true;
        if (nextStatus) nextStatus.textContent = window.nusswahnDiscountAdded;
      } catch (error) {
        console.error(error);
        input.setAttribute('aria-invalid', 'true');
        status.textContent = window.nusswahnDiscountError;
        status.classList.add('is-error');
      } finally {
        button.disabled = false;
      }
      return;
    }

    const form = event.target.closest('[data-cart-upsell-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    try {
      const formData = new FormData(form);
      formData.append('sections', cartSectionId);
      formData.append('sections_url', window.location.pathname);
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      document.dispatchEvent(new CustomEvent('product:added', { detail: result }));
    } catch (error) {
      // Die englische API-Rohmeldung bleibt in der Konsole, die UI bekommt Locale-Text.
      console.error(error);
      setCartStatus(window.nusswahnCartAddError);
    } finally {
      button.disabled = false;
    }
  });

  document.addEventListener('product:added', (event) => {
    const result = event.detail || {};
    const addedKey = result.key || result.items?.[0]?.key;
    openCartDrawer({
      sectionHtml: result.sections?.[cartSectionId],
      addedKey,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-nusswahn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nusswahn-hero')) {
    customElements.define(
      'nusswahn-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          const listenerOptions = { signal: this.controller.signal };
          this.slides = [...this.querySelectorAll('[data-hero-slide]')];
          this.videos = [...this.querySelectorAll('.nusswahn-hero__video')];
          this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
          if (this.index < 0) this.index = 0;

          this.querySelector('[data-hero-previous]')?.addEventListener(
            'click',
            () => this.show(this.index - 1, 'backward'),
            listenerOptions,
          );
          this.querySelector('[data-hero-next]')?.addEventListener(
            'click',
            () => this.show(this.index + 1, 'forward'),
            listenerOptions,
          );

          this.addEventListener('mouseenter', () => this.stop(), listenerOptions);
          this.addEventListener('mouseleave', () => this.start(), listenerOptions);
          this.addEventListener('focusin', () => this.stop(), listenerOptions);
          this.addEventListener('focusout', () => this.start(), listenerOptions);
          this.addEventListener('touchstart', () => this.stop(), {
            passive: true,
            signal: this.controller.signal,
          });
          this.addEventListener('touchend', () => this.start(), {
            passive: true,
            signal: this.controller.signal,
          });
          this.start();
          this.syncVideos();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.stop();
          window.clearTimeout(this.transitionTimer);
        }

        show(nextIndex, direction = 'forward') {
          if (this.slides.length < 2) return;
          const normalizedIndex = (nextIndex + this.slides.length) % this.slides.length;
          if (normalizedIndex === this.index) return;

          const outgoing = this.slides[this.index];
          const incoming = this.slides[normalizedIndex];
          const enteringClass = `is-entering-${direction}`;
          const leavingClass = `is-leaving-${direction}`;
          const transitionClasses = [
            'is-entering-forward',
            'is-entering-backward',
            'is-leaving-forward',
            'is-leaving-backward',
          ];

          window.clearTimeout(this.transitionTimer);
          this.slides.forEach((slide) => slide.classList.remove(...transitionClasses));
          incoming.classList.add(enteringClass);
          incoming.removeAttribute('aria-hidden');
          incoming.inert = false;
          outgoing.setAttribute('aria-hidden', 'true');
          outgoing.inert = true;
          this.index = normalizedIndex;

          const finish = () => {
            outgoing.classList.remove('is-active', leavingClass);
            incoming.classList.remove(enteringClass);
            incoming.classList.add('is-active');
          };

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            finish();
          } else {
            window.requestAnimationFrame(() => {
              outgoing.classList.remove('is-active');
              outgoing.classList.add(leavingClass);
              incoming.classList.remove(enteringClass);
              incoming.classList.add('is-active');
              this.transitionTimer = window.setTimeout(() => outgoing.classList.remove(leavingClass), 700);
            });
          }
          this.start();
          this.syncVideos();
        }

        syncVideos() {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.videos.forEach((video) => {
            const isActive = video.closest('[data-hero-slide]') === this.slides[this.index];
            if (!isActive || reducedMotion) {
              video.pause();
              return;
            }
            video.play().catch(() => {});
          });
        }

        start() {
          this.stop();
          if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = window.setInterval(
            () => this.show(this.index + 1, 'forward'),
            Number(this.dataset.interval) || 5000,
          );
        }

        stop() {
          window.clearInterval(this.timer);
        }

      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-nusswahn"] && !Shopify.designMode) return;
  try {
    
  /*
   * Die Anmeldung lädt die Seite neu (hCaptcha, siehe Kommentar im Markup). Der Neuladen
   * landet oben, die Bestätigung steht aber unten im Newsletter-Band, wo gerade geklickt
   * wurde. Dieser Block holt sie zurück in den Blick, damit der Sprung nicht wie ein
   * verschlucktes Formular wirkt.
   *
   * Bedingung ist die gerenderte Meldung, nicht der Parameter allein: Nach einer Anmeldung
   * über das Popup steht derselbe Parameter in der Adresse, dort übernimmt aber das Popup.
   * Sprung ohne weiche Animation, sonst scrollt die halbe Seite an einem vorbei.
   */
  (() => {
    if (typeof window === 'undefined') return;
    const start = () => {
      const message = document.querySelector('.newsletter__status .newsletter__message');
      if (!message) return;
      if (!new URLSearchParams(window.location.search).has('customer_posted')) return;
      window.requestAnimationFrame(() => {
        if (document.querySelector('dialog[open]')) return;
        message.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  /*
   * Gemeinsamer Formularzustand für Newsletter, Kontakt und die beiden B2B-Anfragen.
   * Aufgaben: Erfolgs-/Fehlermeldung nach dem Laden in eine echte Live-Region schreiben,
   * beim Absenden einen kurzen Busy-Zustand zeigen und Doppelabsendungen verhindern.
   */
  if (!customElements.get('nw-form-status')) {
    class NwFormStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.timers = [];
        this.busy = false;
        this.form = this.querySelector('form');
        this.announcer = this.querySelector('[data-form-announcer]');
        this.submitButton = this.querySelector('[data-form-submit]');

        this.onSubmit = this.handleSubmit.bind(this);
        this.onPageShow = this.handlePageShow.bind(this);

        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);

        this.announceRenderedMessage();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
        this.clearTimers();
        this.dataset.initialized = 'false';
      }

      clearTimers() {
        (this.timers || []).forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      defer(callback, delay) {
        this.timers.push(window.setTimeout(callback, delay));
      }

      /*
       * Eine Live-Region kündigt Inhalte, die bereits beim Seitenaufbau darin stehen,
       * nicht an. Der sichtbare Text bleibt deshalb statisch und wird kurz nach dem
       * Laden zusätzlich in die leere Live-Region geschrieben.
       */
      announce(message, autoClear) {
        if (!this.announcer || !message) return;
        this.announcer.textContent = '';
        this.defer(() => {
          this.announcer.textContent = message;
        }, 160);
        if (autoClear) {
          this.defer(() => {
            this.announcer.textContent = '';
          }, 6000);
        }
      }

      announceRenderedMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message) return;
        this.announce(message.textContent.replace(/\s+/g, ' ').trim(), true);
      }

      handleSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }
        this.busy = true;
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) timeoutHint.hidden = true;
        this.announce(this.dataset.sendingMessage, false);
        if (!this.submitButton) return;
        this.submitButton.classList.add('is-busy');
        this.submitButton.setAttribute('aria-busy', 'true');
        // Erst nach dem Absenden sperren, damit der Request vollständig abgeht.
        this.defer(() => {
          this.submitButton.disabled = true;
        }, 0);
        this.watchSubmission();
      }

      /*
       * Shopify schickt das Formular erst ab, wenn hCaptcha ein Token geliefert hat, und
       * lädt dann die Seite neu. Bleibt beides aus (Captcha-Skript blockiert, Challenge
       * weggeklickt, Netzwerkfehler), zeigte der Button sonst endlos „Wird gesendet“
       * (Kundenmeldung 16. September 2026, Chrome unter Windows). Solange eine sichtbare
       * Challenge offen ist, warten wir; sonst gibt ein Timeout den Button wieder frei und
       * zeigt den Hinweis aus [data-form-timeout] beziehungsweise data-timeout-message.
       */
      watchSubmission() {
        const limit = Number(this.dataset.submitTimeout) || 15000;
        const graceAfterChallenge = 4000;
        let deadline = Date.now() + limit;
        const tick = () => {
          if (!this.busy) return;
          if (this.hasOpenChallenge()) {
            deadline = Date.now() + graceAfterChallenge;
          } else if (Date.now() >= deadline) {
            this.releaseSubmit();
            return;
          }
          this.defer(tick, 500);
        };
        this.defer(tick, 500);
      }

      hasOpenChallenge() {
        return [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((frame) => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
        });
      }

      releaseSubmit() {
        this.busy = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-busy');
          this.submitButton.removeAttribute('aria-busy');
        }
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) {
          timeoutHint.hidden = false;
          this.announce(timeoutHint.textContent.replace(/\s+/g, ' ').trim(), false);
        } else if (this.dataset.timeoutMessage) {
          this.announce(this.dataset.timeoutMessage, false);
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.clearTimers();
        this.busy = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('is-busy');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    customElements.define('nw-form-status', NwFormStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-newsletter-popup]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const STORAGE_KEY = 'nusswahn:newsletter-popup';
    // Gemeinsamer Riegel mit dem Glücksrad: pro Sitzung erscheint höchstens ein Popup.
    const SESSION_KEY = 'nusswahn:popup-session';
    const DAY = 86400000;
    const BLOCKED_TEMPLATES = ['cart', 'password'];
    const TONES = ['nw-popup--pink', 'nw-popup--bordeaux', 'nw-popup--blue', 'nw-popup--yellow'];

    const formArea = dialog.querySelector('[data-newsletter-popup-form]');
    const successArea = dialog.querySelector('[data-newsletter-popup-success]');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);

    const readState = () => {
      try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
      } catch (error) {
        return {};
      }
    };

    const writeState = (state) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (error) {
        // Privater Modus ohne Storage: Das Popup verhält sich dann wie beim ersten Besuch.
      }
    };

    const claimSession = () => {
      try {
        if (window.sessionStorage.getItem(SESSION_KEY)) return false;
        window.sessionStorage.setItem(SESSION_KEY, 'newsletter');
      } catch (error) {
        // Ohne Storage bleibt es beim Standardverhalten.
      }
      return true;
    };

    /*
     * Beide Formulare, das im Popup und das Band im Footer, sind dasselbe Shopify-
     * Kundenformular. Nach dem Absenden gilt form.posted_successfully? deshalb für beide,
     * und das Popup sprang bis zum 3. August 2026 auch dann auf, wenn man sich unten im
     * Footer eingetragen hatte. Wer dort unterschreibt, will keine zweite Aufforderung,
     * sondern eine Bestätigung an Ort und Stelle.
     *
     * Die Herkunft merkt sich deshalb das Popup selbst, kurz bevor sein Formular abgeht.
     * Fällt der Storage aus, gilt bewusst die alte Regel: Lieber ein Popup zu viel als ein
     * verlorener Rabattcode, denn den zeigt ausschließlich das Popup.
     */
    const ORIGIN_KEY = 'nusswahn:newsletter-popup-origin';
    const markPopupOrigin = () => {
      try {
        window.sessionStorage.setItem(ORIGIN_KEY, '1');
      } catch (error) {
        // Ohne Storage greift unten der Fallback.
      }
    };
    const cameFromPopup = () => {
      try {
        const flag = window.sessionStorage.getItem(ORIGIN_KEY);
        window.sessionStorage.removeItem(ORIGIN_KEY);
        return flag === '1';
      } catch (error) {
        return true;
      }
    };

    formArea?.querySelector('form')?.addEventListener('submit', markPopupOrigin);

    const open = () => {
      if (dialog.open) return;
      // Der Grundton wechselt bei jedem Öffnen; die Zahl bekommt so jedes Mal eine eigene Bühne.
      dialog.classList.remove(...TONES);
      dialog.classList.add(TONES[Math.floor(Math.random() * TONES.length)]);
      dialog.showModal();
      requestAnimationFrame(() => dialog.classList.add('is-open'));
    };

    const close = () => {
      if (!dialog.open) return;
      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      window.setTimeout(() => {
        dialog.classList.remove('is-closing');
        dialog.close();
      }, 220);
    };

    const dismiss = () => {
      const snooze = Number(dialog.dataset.snooze) || 30;
      const state = readState();
      // Eine Anmeldung wiegt schwerer als ein Wegklicken und bleibt bestehen.
      if (state.status !== 'subscribed') {
        writeState({ status: 'dismissed', until: Date.now() + snooze * DAY });
      }
      close();
    };

    const showSuccess = () => {
      writeState({ status: 'subscribed' });
      if (formArea) formArea.hidden = true;
      if (successArea) successArea.hidden = false;
    };

    dialog.querySelector('[data-newsletter-popup-close]')?.addEventListener('click', dismiss);
    // Escape läuft über das native cancel-Event, damit auch dort die Pause greift.
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dismiss();
    });

    const copyButton = dialog.querySelector('[data-newsletter-popup-copy]');
    copyButton?.addEventListener('click', async () => {
      const code = dialog.querySelector('[data-newsletter-popup-code]')?.textContent.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        // Ohne Clipboard-Rechte bleibt der Code markierbar (user-select: all).
        return;
      }
      const original = copyButton.textContent;
      copyButton.textContent = copyButton.dataset.copiedLabel || original;
      window.setTimeout(() => {
        copyButton.textContent = original;
      }, 1800);
    });

    // Nach dem Absenden lädt Shopify die Seite neu und rendert den Erfolg serverseitig.
    if (successArea && !successArea.hidden) {
      if (!cameFromPopup()) {
        // Anmeldung über das Band im Footer: Dort steht die Bestätigung bereits im Bild.
        writeState({ status: 'subscribed' });
        return;
      }
      showSuccess();
      open();
      return;
    }

    if (BLOCKED_TEMPLATES.includes(dialog.dataset.template)) return;

    const state = readState();
    if (!designMode) {
      if (state.status === 'subscribed') return;
      if (state.status === 'dismissed' && Date.now() < Number(state.until || 0)) return;
    }

    const delay = (Number(dialog.dataset.delay) || 9) * 1000;
    const tryOpen = (attempt = 0) => {
      // Warenkorb, Suche, mobiles Menü und die offene Cookie-Frage haben Vorrang;
      // das Popup wartet kurz ab, statt sich über die Einwilligung zu legen.
      if (document.querySelector('dialog[open], nusswahn-cookie-banner.is-open')) {
        if (attempt < 3) window.setTimeout(() => tryOpen(attempt + 1), 6000);
        return;
      }
      if (!claimSession()) return;
      open();
    };

    window.setTimeout(tryOpen, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nussmussbar-order-nusswahn"]) return;
  try {
    
  if (!customElements.get('nussmussbar-order')) {
    class NussmussbarOrder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.steps = {
          1: this.querySelector('[data-order-step="1"]'),
          2: this.querySelector('[data-order-step="2"]'),
        };
        this.currentStep = 1;
        this.deliveryLimit = 50;
        this.promoGroupSize = 6;
        this.form = this.closest('form');
        this.progressItems = [...this.querySelectorAll('[data-order-progress]')];
        this.finalLabel = this.querySelector('[data-order-final-label]');
        this.errorBox = this.querySelector('[data-order-error]');
        this.fields = this.querySelector('[data-order-fields]');
        this.companyInput = this.querySelector('[data-order-company]');
        this.nameField = this.querySelector('[data-order-name-field]');
        this.nameInput = this.querySelector('[data-order-name]');
        this.nameRequired = this.querySelector('[data-order-name-required]');
        this.emailInput = this.querySelector('[data-order-email]');
        this.locationInput = this.querySelector('[data-order-location]');
        this.deliveryFields = [...this.querySelectorAll('[data-order-delivery-field]')];
        this.nextButton = this.querySelector('[data-order-next]');
        this.backButton = this.querySelector('[data-order-back]');
        this.checkoutButton = this.querySelector('[data-order-checkout]');
        this.actionLabel = this.querySelector('[data-order-action-label]');
        this.actionBusy = this.querySelector('[data-order-action-busy]');
        this.submitNote = this.querySelector('[data-order-submit-note]');
        this.countLabel = this.querySelector('[data-order-count]');
        this.totalLabel = this.querySelector('[data-order-total]');
        this.quantityStatus = this.querySelector('[data-order-quantity-status]');
        this.cards = [...this.querySelectorAll('[data-order-card]')];
        this.progressBar = this.querySelector('[data-order-progressbar]');
        this.grid = this.querySelector('[data-order-grid]');
        this.viewButtons = [...this.querySelectorAll('[data-order-view]')];
        this.randomMixButton = this.querySelector('[data-order-randomize]');
        this.resetButton = this.querySelector('[data-order-reset]');
        // Selbstzahler-Aktion „6 nehmen, 5 zahlen“ nur, wenn die Section sie freischaltet
        // (Rabatt muss im Admin existieren); der optionale Code geht an den Cart-Permalink.
        this.pickupPromo = this.dataset.pickupPromo === 'true';
        this.pickupDiscount = (this.dataset.pickupDiscount || '').trim();
        this.requestCount = this.form?.querySelector('[data-order-request-count]');
        this.requestFree = this.form?.querySelector('[data-order-request-free]');
        this.requestPaid = this.form?.querySelector('[data-order-request-paid]');
        this.requestTotal = this.form?.querySelector('[data-order-request-total]');
        this.requestSelection = this.form?.querySelector('[data-order-request-selection]');
        this.requestBody = this.form?.querySelector('[data-order-request-body]');
        this.formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
        this.isSubmitting = false;

        this.addEventListener('click', this.handleClick.bind(this), { signal });
        this.addEventListener('input', this.handleInput.bind(this), { signal });
        this.addEventListener('change', this.handleChange.bind(this), { signal });
        this.form?.addEventListener('submit', this.handleSubmit.bind(this), { signal });
        window.addEventListener('pageshow', this.resetSubmitState.bind(this), { signal });

        let storedView = null;
        try {
          storedView = sessionStorage.getItem('nusswahn:order-view');
        } catch (error) {
          storedView = null;
        }
        if (storedView === 'list') this.setView('list');

        if (this.mode) {
          this.applyMode();
        } else {
          this.updateSummary();
        }
        this.removeAttribute('hidden');

        if (this.dataset.orderRetryDelivery === 'true') {
          const restoredSelection = this.restoreRequest();
          if (restoredSelection) this.showStep(2);
          this.errorBox.focus();
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.dataset.initialized = 'false';
      }

      get mode() {
        return this.querySelector('[data-order-mode]:checked')?.value || null;
      }

      handleChange(event) {
        if (event.target.matches('[data-order-mode]')) {
          this.clearError();
          this.applyMode();
        }
        if (event.target.matches('[data-order-qty]')) {
          this.setQuantity(event.target, event.target.value);
        }
      }

      handleInput(event) {
        if (event.target.matches('[data-order-qty]')) {
          const input = event.target;
          if (input.value === '') {
            this.updateSummary();
          } else {
            this.setQuantity(input, input.value);
          }
        }
        if (event.target.matches('[data-order-company], [data-order-name], [data-order-email]')) {
          this.clearError();
        }
      }

      handleClick(event) {
        const change = event.target.closest('[data-order-change]');
        if (change) {
          const input = change.closest('[data-order-stepper]').querySelector('[data-order-qty]');
          const value = (parseInt(input.value, 10) || 0) + Number(change.dataset.orderChange);
          this.setQuantity(input, value, true);
          return;
        }
        const viewButton = event.target.closest('[data-order-view]');
        if (viewButton) {
          this.setView(viewButton.dataset.orderView);
          return;
        }
        if (event.target.closest('[data-order-randomize]')) {
          this.randomizeSelection();
          return;
        }
        if (event.target.closest('[data-order-reset]')) {
          this.resetSelection();
          return;
        }
        if (event.target.closest('[data-order-next]')) this.goToStep2();
        if (event.target.closest('[data-order-back]')) {
          // „Zurück“ ist ein Neustart: Die Auswahl wird geleert (Nutzerentscheid 16. September 2026).
          this.resetSelection();
          this.showStep(1);
        }
        if (event.target.closest('[data-order-checkout]')) {
          if (this.mode === 'lieferung') {
            this.requestRefill();
          } else {
            this.checkout();
          }
        }
      }

      handleSubmit(event) {
        if (this.isSubmitting) {
          event.preventDefault();
          return;
        }
        if (this.mode !== 'lieferung' || this.currentStep !== 2) {
          event.preventDefault();
          this.goToStep2();
          return;
        }

        const selection = this.collectItems();
        if (!selection.items.length) {
          event.preventDefault();
          this.showError(this.checkoutButton.dataset.errorEmpty);
          return;
        }
        if (selection.count > this.deliveryLimit) {
          event.preventDefault();
          this.showError(this.checkoutButton.dataset.errorLimit);
          return;
        }

        this.syncRequestFields(selection);
        this.isSubmitting = true;
        this.checkoutButton.classList.add('is-busy');
        this.checkoutButton.disabled = true;
        this.actionBusy.hidden = false;
        this.quantityStatus.textContent = this.quantityStatus.dataset.sending;
      }

      setView(view) {
        if (this.grid) this.grid.classList.toggle('nussmussbar-order__grid--list', view === 'list');
        this.viewButtons.forEach((button) => {
          const active = button.dataset.orderView === view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        try {
          sessionStorage.setItem('nusswahn:order-view', view);
        } catch (error) {
          /* Private-Mode-Safari wirft hier; die Ansicht gilt dann nur für diese Seite. */
        }
      }

      goToStep2() {
        if (!this.mode) {
          this.showError(this.nextButton.dataset.errorMode);
          this.querySelector('[data-order-mode]')?.focus();
          return;
        }
        if (!this.companyInput.value.trim()) {
          this.showError(this.nextButton.dataset.errorCompany);
          this.companyInput.focus();
          return;
        }
        if (this.mode === 'lieferung' && !this.nameInput.value.trim()) {
          this.showError(this.nextButton.dataset.errorName);
          this.nameInput.focus();
          return;
        }
        if (this.mode === 'lieferung' && !this.emailInput.validity.valid) {
          this.showError(this.nextButton.dataset.errorEmail);
          this.emailInput.focus();
          return;
        }
        this.clearError();
        this.applyAvailability();
        this.showStep(2);
        if (this.mode === 'lieferung' && this.collectItems().count > this.deliveryLimit) {
          this.showError(this.checkoutButton.dataset.errorLimit);
        }
      }

      showStep(step) {
        this.currentStep = step;
        this.steps[1].hidden = step !== 1;
        this.steps[2].hidden = step !== 2;
        this.progressItems.forEach((item) => {
          const itemStep = Number(item.dataset.orderProgress);
          if (itemStep === step) {
            item.setAttribute('aria-current', 'step');
          } else {
            item.removeAttribute('aria-current');
          }
          item.classList.toggle('is-done', itemStep < step);
        });
        if (this.progressBar) {
          this.progressBar.style.setProperty('--order-progress', step === 2 ? '0.5' : '0');
        }
        const heading = this.querySelector(`[data-order-step-heading="${step}"]`);
        if (heading) heading.focus();
      }

      applyMode() {
        const hasMode = Boolean(this.mode);
        const delivery = this.mode === 'lieferung';
        this.fields.hidden = !hasMode;
        this.nextButton.hidden = !hasMode;
        this.nameField.hidden = !delivery;
        this.deliveryFields.forEach((field) => {
          field.hidden = !delivery;
        });
        this.nameInput.disabled = !delivery;
        this.nameInput.required = delivery;
        this.nameInput.setAttribute('aria-required', String(delivery));
        this.nameRequired.hidden = !delivery;
        this.emailInput.disabled = !delivery;
        this.emailInput.required = delivery;
        this.emailInput.setAttribute('aria-required', String(delivery));
        this.locationInput.disabled = !delivery;
        this.finalLabel.textContent = delivery
          ? this.finalLabel.dataset.labelRequest
          : this.finalLabel.dataset.labelCheckout;
        this.actionLabel.textContent = delivery
          ? this.actionLabel.dataset.labelRequest
          : this.actionLabel.dataset.labelCheckout;
        this.submitNote.hidden = !delivery;
        this.applyAvailability();
        if (delivery && this.collectItems().count > this.deliveryLimit) {
          this.clampDeliverySelection();
        }
      }

      applyAvailability() {
        const mode = this.mode;
        const delivery = mode === 'lieferung';
        this.cards.forEach((card) => {
          const variantId = delivery ? card.dataset.variantLieferung : card.dataset.variantAufsteller;
          const available = delivery ? card.dataset.availableLieferung : card.dataset.availableAufsteller;
          const usable = Boolean(variantId) && available === 'true';
          card.classList.toggle('is-unavailable', !usable);
          card.querySelector('[data-order-soldout]').hidden = usable;
          card.querySelectorAll('[data-order-price]').forEach((price) => {
            price.hidden = price.dataset.orderPrice !== (delivery ? 'lieferung' : 'aufsteller');
          });
          const qty = card.querySelector('[data-order-qty]');
          qty.disabled = !usable;
          if (!usable) {
            qty.value = 0;
          }
        });
        if (this.randomMixButton) {
          // Nur im Büro-Nachfüllpfad; am Aufsteller ergibt ein Zufallsmix keinen Sinn.
          this.randomMixButton.hidden = !delivery;
          this.randomMixButton.disabled = !this.cards.some((card) => !card.classList.contains('is-unavailable'));
        }
        this.updateSummary();
      }

      randomizeSelection() {
        const usableCards = this.cards.filter((card) => !card.classList.contains('is-unavailable'));
        if (!usableCards.length) return;

        // Fester Mix: 50 Tüten aus 10 zufälligen Sorten zu je 5 (data-mix-*), eine
        // bestehende Auswahl wird ersetzt. Bei weniger verfügbaren Sorten wird die Menge
        // gleichmäßig verteilt, im Büro-Modus auf das Kapazitätslimit gedeckelt.
        const requestedCount = Number(this.randomMixButton?.dataset.mixCount) || 50;
        const requestedVarieties = Number(this.randomMixButton?.dataset.mixVarieties) || 10;
        const varietyCount = Math.max(1, Math.min(requestedVarieties, usableCards.length));
        const maximum = this.mode === 'lieferung' ? this.deliveryLimit : varietyCount * 99;
        const targetCount = Math.min(requestedCount, maximum);
        const shuffledCards = [...usableCards];

        for (let index = shuffledCards.length - 1; index > 0; index -= 1) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [shuffledCards[index], shuffledCards[randomIndex]] = [shuffledCards[randomIndex], shuffledCards[index]];
        }

        this.cards.forEach((card) => {
          card.querySelector('[data-order-qty]').value = 0;
        });
        const baseShare = Math.floor(targetCount / varietyCount);
        let remainder = targetCount - baseShare * varietyCount;
        shuffledCards.slice(0, varietyCount).forEach((card) => {
          const extra = remainder > 0 ? 1 : 0;
          remainder -= extra;
          card.querySelector('[data-order-qty]').value = baseShare + extra;
        });

        this.clearError();
        this.updateSummary();
        if (this.quantityStatus && this.randomMixButton?.dataset.statusTemplate) {
          this.quantityStatus.textContent = this.randomMixButton.dataset.statusTemplate.replace(
            '__count__',
            targetCount,
          );
        }
      }

      resetSelection() {
        this.cards.forEach((card) => {
          card.querySelector('[data-order-qty]').value = 0;
        });
        this.clearError();
        this.updateSummary();
        if (this.quantityStatus && this.resetButton?.dataset.statusReset) {
          this.quantityStatus.textContent = this.resetButton.dataset.statusReset;
        }
      }

      setQuantity(input, rawValue, announce = false) {
        const parsedValue = parseInt(rawValue, 10);
        const requested = Number.isFinite(parsedValue) ? Math.max(0, parsedValue) : 0;
        let allowed = 99;

        if (this.mode === 'lieferung') {
          const otherCount = this.cards.reduce((sum, card) => {
            const cardInput = card.querySelector('[data-order-qty]');
            if (cardInput === input || card.classList.contains('is-unavailable')) return sum;
            return sum + (parseInt(cardInput.value, 10) || 0);
          }, 0);
          allowed = Math.max(0, this.deliveryLimit - otherCount);
        }

        const value = Math.min(allowed, requested);
        input.value = value;
        if (announce && this.quantityStatus) {
          this.quantityStatus.textContent = this.quantityStatus.dataset.quantityTemplate.replace(
            '__quantity__',
            value,
          );
        }
        this.updateSummary();
        if (requested > allowed) this.showNotice(this.checkoutButton.dataset.noticeLimit);
      }

      clampDeliverySelection() {
        let remaining = this.deliveryLimit;
        this.cards.forEach((card) => {
          const input = card.querySelector('[data-order-qty]');
          const quantity = parseInt(input.value, 10) || 0;
          const clamped = Math.min(quantity, remaining);
          input.value = clamped;
          remaining -= clamped;
        });
        this.updateSummary();
        this.showNotice(this.checkoutButton.dataset.noticeLimit);
      }

      collectItems() {
        const mode = this.mode;
        const items = [];
        const selections = [];
        let count = 0;
        let totalCents = 0;
        this.cards.forEach((card) => {
          if (card.classList.contains('is-unavailable')) return;
          const qty = parseInt(card.querySelector('[data-order-qty]').value, 10) || 0;
          if (qty < 1) return;
          const variantId = mode === 'lieferung' ? card.dataset.variantLieferung : card.dataset.variantAufsteller;
          if (!variantId) return;
          items.push(`${variantId}:${qty}`);
          const priceCents = Number(
            mode === 'lieferung' ? card.dataset.priceLieferung : card.dataset.priceAufsteller,
          );
          selections.push({ name: card.dataset.orderName, qty, variantId, priceCents });
          count += qty;
          totalCents += qty * priceCents;
        });
        return { items, selections, count, totalCents };
      }

      calculatePromotion(selection) {
        const free = Math.floor(selection.count / this.promoGroupSize);
        const paid = selection.count - free;
        let freeRemaining = free;
        let discountCents = 0;
        const byPrice = [...selection.selections].sort((a, b) => a.priceCents - b.priceCents);
        byPrice.forEach((item) => {
          if (freeRemaining < 1) return;
          const freeFromItem = Math.min(item.qty, freeRemaining);
          discountCents += freeFromItem * item.priceCents;
          freeRemaining -= freeFromItem;
        });
        return {
          free,
          paid,
          totalCents: Math.max(0, selection.totalCents - discountCents),
        };
      }

      updateSummary() {
        const selection = this.collectItems();
        const { items, count, totalCents } = selection;
        const delivery = this.mode === 'lieferung';
        const promotion = this.calculatePromotion(selection);
        if (this.countLabel) {
          if (delivery) {
            this.countLabel.textContent = this.countLabel.dataset.countDelivery.replace('__count__', count);
          } else {
            this.countLabel.textContent = count === 1
              ? this.countLabel.dataset.countOne
              : this.countLabel.dataset.countOther.replace('__count__', count);
          }
        }
        if (this.resetButton) this.resetButton.disabled = count === 0;
        if (this.totalLabel) {
          const promoActive = delivery || this.pickupPromo;
          const formattedTotal = this.formatter.format((promoActive ? promotion.totalCents : totalCents) / 100);
          this.totalLabel.hidden = false;
          this.totalLabel.textContent = delivery
            ? this.totalLabel.dataset.deliveryTemplate.replace('__total__', formattedTotal)
            : formattedTotal;
        }
        if (this.checkoutButton) {
          this.checkoutButton.disabled = items.length === 0 || (delivery && count > this.deliveryLimit);
        }
        this.updateQuantityControls(count);
        if (
          delivery
          && count <= this.deliveryLimit
          && this.errorBox.textContent === this.checkoutButton.dataset.errorLimit
        ) {
          this.clearError();
        }
        if (
          delivery
          && count < this.deliveryLimit
          && this.errorBox.textContent === this.checkoutButton.dataset.noticeLimit
        ) {
          this.clearError();
        }
      }

      updateQuantityControls(totalCount) {
        const deliveryAtLimit = this.mode === 'lieferung' && totalCount >= this.deliveryLimit;
        this.cards.forEach((card) => {
          const input = card.querySelector('[data-order-qty]');
          const quantity = parseInt(input.value, 10) || 0;
          const unavailable = card.classList.contains('is-unavailable');
          const minus = card.querySelector('[data-order-change="-1"]');
          const plus = card.querySelector('[data-order-change="1"]');
          minus.disabled = unavailable || quantity === 0;
          plus.disabled = unavailable || deliveryAtLimit;
          input.max = this.mode === 'lieferung'
            ? String(Math.max(quantity, quantity + this.deliveryLimit - totalCount))
            : '99';
        });
      }

      requestRefill() {
        const selection = this.collectItems();
        if (!selection.items.length) {
          this.showError(this.checkoutButton.dataset.errorEmpty);
          return;
        }
        if (selection.count > this.deliveryLimit) {
          this.showError(this.checkoutButton.dataset.errorLimit);
          return;
        }
        this.syncRequestFields(selection);
        this.form?.requestSubmit();
      }

      syncRequestFields(selection) {
        const { free, paid, totalCents } = this.calculatePromotion(selection);
        const formattedTotal = this.formatter.format(totalCents / 100);
        const lines = selection.selections.map((item) => `${item.name} × ${item.qty}`);
        const summary = [
          `Firma: ${this.companyInput.value.trim()}`,
          `Ansprechpartner: ${this.nameInput.value.trim()}`,
          `E-Mail: ${this.emailInput.value.trim()}`,
          `Standort: ${this.locationInput.value.trim() || 'nicht angegeben'}`,
          '',
          'Auswahl:',
          ...lines,
          '',
          `Gesamt: ${selection.count} Tüten`,
          `Gratis (6 nehmen, 5 zahlen): ${free}`,
          `Zu berechnen: ${paid} Tüten`,
          `Voraussichtlicher Gesamtpreis: ${formattedTotal}`,
          'Lieferung: kostenlos',
        ].join('\n');

        this.requestCount.value = String(selection.count);
        this.requestFree.value = String(free);
        this.requestPaid.value = String(paid);
        this.requestTotal.value = formattedTotal;
        this.requestSelection.value = lines.join('\n');
        this.requestBody.value = summary;
      }

      restoreRequest() {
        const body = this.requestBody?.value || '';
        if (!body) return false;
        const lines = body.split(/\r?\n/);
        const restoreField = (label, input) => {
          const line = lines.find((entry) => entry.startsWith(`${label}: `));
          if (!line || input.value.trim()) return;
          const value = line.slice(label.length + 2);
          if (value !== 'nicht angegeben') input.value = value;
        };

        restoreField('Firma', this.companyInput);
        restoreField('Ansprechpartner', this.nameInput);
        restoreField('E-Mail', this.emailInput);
        restoreField('Standort', this.locationInput);

        let restored = false;
        this.cards.forEach((card) => {
          const prefix = `${card.dataset.orderName} × `;
          const line = lines.find((entry) => entry.startsWith(prefix));
          if (!line) return;
          const input = card.querySelector('[data-order-qty]');
          const quantity = Math.min(this.deliveryLimit, Math.max(0, parseInt(line.slice(prefix.length), 10) || 0));
          input.value = quantity;
          restored = restored || quantity > 0;
        });
        if (this.collectItems().count > this.deliveryLimit) {
          this.clampDeliverySelection();
        } else {
          this.updateSummary();
        }
        return restored;
      }

      resetSubmitState() {
        this.isSubmitting = false;
        this.checkoutButton?.classList.remove('is-busy');
        if (this.actionBusy) this.actionBusy.hidden = true;
        this.updateSummary();
      }

      checkout() {
        const { items } = this.collectItems();
        if (!items.length) {
          this.showError(this.checkoutButton.dataset.errorEmpty);
          return;
        }
        const params = new URLSearchParams();
        params.append('attributes[Bestellart]', 'Selbstzahler');
        params.append('attributes[Firma]', this.companyInput.value.trim());
        if (this.pickupPromo && this.pickupDiscount) params.append('discount', this.pickupDiscount);
        window.location.assign(`/cart/${items.join(',')}?${params.toString()}`);
      }

      showError(message) {
        this.errorBox.classList.remove('is-notice');
        this.errorBox.textContent = message;
      }

      showNotice(message) {
        this.errorBox.classList.add('is-notice');
        this.errorBox.textContent = message;
      }

      clearError() {
        this.errorBox.classList.remove('is-notice');
        this.errorBox.textContent = '';
      }
    }
    customElements.define('nussmussbar-order', NussmussbarOrder);
  }

  document.querySelector('[data-order-success]')?.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nussmussbar-request-nusswahn"] && !Shopify.designMode) return;
  try {
    
  /*
   * Gemeinsamer Formularzustand für Newsletter, Kontakt und die B2B-Anfragen.
   * Aufgaben: Erfolgs-/Fehlermeldung nach dem Laden in eine echte Live-Region
   * schreiben, beim Absenden einen kurzen Busy-Zustand zeigen und
   * Doppelabsendungen verhindern. Die Definition ist identisch zu
   * product-inquiry-nusswahn; der customElements.get()-Riegel entscheidet,
   * welche zuerst registriert. Zusätzlich hier: scopeMessage() für Seiten mit
   * zwei Kontaktformularen.
   */
  if (!customElements.get('nw-form-status')) {
    class NwFormStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.timers = [];
        this.busy = false;
        this.form = this.querySelector('form');
        this.announcer = this.querySelector('[data-form-announcer]');
        this.submitButton = this.querySelector('[data-form-submit]');

        this.onSubmit = this.handleSubmit.bind(this);
        this.onPageShow = this.handlePageShow.bind(this);

        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);

        this.scopeMessage();
        this.announceRenderedMessage();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
        this.clearTimers();
        this.dataset.initialized = 'false';
      }

      clearTimers() {
        (this.timers || []).forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      defer(callback, delay) {
        this.timers.push(window.setTimeout(callback, delay));
      }

      /*
       * Stehen zwei Kontaktformulare auf einer Seite, meldet Shopify beide als
       * erfolgreich abgesendet. Nennt das Fragment das tatsächlich abgesendete
       * Formular, entfernt diese Prüfung die Meldung in allen anderen. Ohne
       * passendes Fragment bleibt alles unverändert stehen.
       */
      scopeMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message || !this.form || !this.form.id) return;
        const target = window.location.hash.slice(1);
        if (target.indexOf('NussmussbarForm-') !== 0) return;
        if (target === this.form.id) return;
        message.remove();
      }

      /*
       * Eine Live-Region kündigt Inhalte, die bereits beim Seitenaufbau darin stehen,
       * nicht an. Der sichtbare Text bleibt deshalb statisch und wird kurz nach dem
       * Laden zusätzlich in die leere Live-Region geschrieben.
       */
      announce(message, autoClear) {
        if (!this.announcer || !message) return;
        this.announcer.textContent = '';
        this.defer(() => {
          this.announcer.textContent = message;
        }, 160);
        if (autoClear) {
          this.defer(() => {
            this.announcer.textContent = '';
          }, 6000);
        }
      }

      announceRenderedMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message) return;
        this.announce(message.textContent.replace(/\s+/g, ' ').trim(), true);
      }

      handleSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }
        this.busy = true;
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) timeoutHint.hidden = true;
        this.announce(this.dataset.sendingMessage, false);
        if (!this.submitButton) return;
        this.submitButton.classList.add('is-busy');
        this.submitButton.setAttribute('aria-busy', 'true');
        // Erst nach dem Absenden sperren, damit der Request vollständig abgeht.
        this.defer(() => {
          this.submitButton.disabled = true;
        }, 0);
        this.watchSubmission();
      }

      /*
       * Shopify schickt das Formular erst ab, wenn hCaptcha ein Token geliefert hat, und
       * lädt dann die Seite neu. Bleibt beides aus (Captcha-Skript blockiert, Challenge
       * weggeklickt, Netzwerkfehler), zeigte der Button sonst endlos „Wird gesendet“
       * (Kundenmeldung 16. September 2026, Chrome unter Windows). Solange eine sichtbare
       * Challenge offen ist, warten wir; sonst gibt ein Timeout den Button wieder frei und
       * zeigt den Hinweis aus [data-form-timeout] beziehungsweise data-timeout-message.
       */
      watchSubmission() {
        const limit = Number(this.dataset.submitTimeout) || 15000;
        const graceAfterChallenge = 4000;
        let deadline = Date.now() + limit;
        const tick = () => {
          if (!this.busy) return;
          if (this.hasOpenChallenge()) {
            deadline = Date.now() + graceAfterChallenge;
          } else if (Date.now() >= deadline) {
            this.releaseSubmit();
            return;
          }
          this.defer(tick, 500);
        };
        this.defer(tick, 500);
      }

      hasOpenChallenge() {
        return [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((frame) => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
        });
      }

      releaseSubmit() {
        this.busy = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-busy');
          this.submitButton.removeAttribute('aria-busy');
        }
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) {
          timeoutHint.hidden = false;
          this.announce(timeoutHint.textContent.replace(/\s+/g, ' ').trim(), false);
        } else if (this.dataset.timeoutMessage) {
          this.announce(this.dataset.timeoutMessage, false);
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.clearTimers();
        this.busy = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('is-busy');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    customElements.define('nw-form-status', NwFormStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-box-selector"]) return;
  try {
    
  class BoxProductSelector extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-box-selector-status]');
      this.totalWeight = this.querySelector('[data-box-total-weight]');
      this.totalWeightPending = this.totalWeight?.textContent.trim() || '';
      this.handleClick = (event) => {
        const button = event.target.closest('[data-box-choice]');
        if (!button || !this.contains(button)) return;
        this.selectVariant(button);
      };
      this.addEventListener('click', this.handleClick);
    }

    selectVariant(button) {
      const productView = document.querySelector(
        `product-view[data-product-id="${CSS.escape(this.dataset.productId)}"]`,
      );
      if (!productView || typeof productView.updateBoxVariant !== 'function') return;

      const wasSelected = button.getAttribute('aria-pressed') === 'true';
      productView.updateBoxVariant(button.dataset.boxVariantId);
      this.querySelectorAll('[data-box-choice]').forEach((choice) => {
        choice.setAttribute('aria-pressed', String(choice === button));
      });
      const totalWeightLabel = this.updateWeightSummary(button);
      if (this.status) {
        const template = totalWeightLabel
          ? this.status.dataset.selectedWeightTemplate
          : this.status.dataset.selectedTemplate;
        this.status.textContent = template
          .replace('__variant__', button.dataset.boxVariantTitle)
          .replace('__weight__', totalWeightLabel || '');
      }
      if (!wasSelected) this.pulseChoice(button);
    }

    updateWeightSummary(button) {
      const fixedWeight = Number(this.dataset.fixedWeightGrams);
      const selectedWeight = Number(button.dataset.boxFillWeightGrams);
      if (!this.totalWeight || !Number.isFinite(fixedWeight) || !Number.isFinite(selectedWeight)) {
        if (this.totalWeight) this.totalWeight.textContent = this.totalWeightPending;
        return '';
      }
      const totalWeightLabel = this.formatWeight(fixedWeight + selectedWeight);
      this.totalWeight.textContent = totalWeightLabel;
      return totalWeightLabel;
    }

    formatWeight(grams) {
      if (grams < 1000) return `${Math.round(grams).toLocaleString('de-DE')} g`;
      return `${new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(grams / 1000)} kg`;
    }

    pulseChoice(button) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      button.removeAttribute('data-selection-pulse');
      void button.offsetWidth;
      button.dataset.selectionPulse = 'true';
      const visual = button.querySelector('.box-product-selector__visual');
      visual?.addEventListener('animationend', () => button.removeAttribute('data-selection-pulse'), {
        once: true,
      });
    }

    disconnectedCallback() {
      if (this.handleClick) this.removeEventListener('click', this.handleClick);
    }
  }

  if (!customElements.get('box-product-selector')) {
    customElements.define('box-product-selector', BoxProductSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-inquiry-nusswahn"] && !Shopify.designMode) return;
  try {
    
  /*
   * Gemeinsamer Formularzustand für Newsletter, Kontakt und die beiden B2B-Anfragen.
   * Aufgaben: Erfolgs-/Fehlermeldung nach dem Laden in eine echte Live-Region schreiben,
   * beim Absenden einen kurzen Busy-Zustand zeigen und Doppelabsendungen verhindern.
   */
  if (!customElements.get('nw-form-status')) {
    class NwFormStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.timers = [];
        this.busy = false;
        this.form = this.querySelector('form');
        this.announcer = this.querySelector('[data-form-announcer]');
        this.submitButton = this.querySelector('[data-form-submit]');

        this.onSubmit = this.handleSubmit.bind(this);
        this.onPageShow = this.handlePageShow.bind(this);

        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);

        this.announceRenderedMessage();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
        this.clearTimers();
        this.dataset.initialized = 'false';
      }

      clearTimers() {
        (this.timers || []).forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      defer(callback, delay) {
        this.timers.push(window.setTimeout(callback, delay));
      }

      /*
       * Eine Live-Region kündigt Inhalte, die bereits beim Seitenaufbau darin stehen,
       * nicht an. Der sichtbare Text bleibt deshalb statisch und wird kurz nach dem
       * Laden zusätzlich in die leere Live-Region geschrieben.
       */
      announce(message, autoClear) {
        if (!this.announcer || !message) return;
        this.announcer.textContent = '';
        this.defer(() => {
          this.announcer.textContent = message;
        }, 160);
        if (autoClear) {
          this.defer(() => {
            this.announcer.textContent = '';
          }, 6000);
        }
      }

      announceRenderedMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message) return;
        this.announce(message.textContent.replace(/\s+/g, ' ').trim(), true);
      }

      handleSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }
        this.busy = true;
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) timeoutHint.hidden = true;
        this.announce(this.dataset.sendingMessage, false);
        if (!this.submitButton) return;
        this.submitButton.classList.add('is-busy');
        this.submitButton.setAttribute('aria-busy', 'true');
        // Erst nach dem Absenden sperren, damit der Request vollständig abgeht.
        this.defer(() => {
          this.submitButton.disabled = true;
        }, 0);
        this.watchSubmission();
      }

      /*
       * Shopify schickt das Formular erst ab, wenn hCaptcha ein Token geliefert hat, und
       * lädt dann die Seite neu. Bleibt beides aus (Captcha-Skript blockiert, Challenge
       * weggeklickt, Netzwerkfehler), zeigte der Button sonst endlos „Wird gesendet“
       * (Kundenmeldung 16. September 2026, Chrome unter Windows). Solange eine sichtbare
       * Challenge offen ist, warten wir; sonst gibt ein Timeout den Button wieder frei und
       * zeigt den Hinweis aus [data-form-timeout] beziehungsweise data-timeout-message.
       */
      watchSubmission() {
        const limit = Number(this.dataset.submitTimeout) || 15000;
        const graceAfterChallenge = 4000;
        let deadline = Date.now() + limit;
        const tick = () => {
          if (!this.busy) return;
          if (this.hasOpenChallenge()) {
            deadline = Date.now() + graceAfterChallenge;
          } else if (Date.now() >= deadline) {
            this.releaseSubmit();
            return;
          }
          this.defer(tick, 500);
        };
        this.defer(tick, 500);
      }

      hasOpenChallenge() {
        return [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((frame) => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
        });
      }

      releaseSubmit() {
        this.busy = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-busy');
          this.submitButton.removeAttribute('aria-busy');
        }
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) {
          timeoutHint.hidden = false;
          this.announce(timeoutHint.textContent.replace(/\s+/g, ' ').trim(), false);
        } else if (this.dataset.timeoutMessage) {
          this.announce(this.dataset.timeoutMessage, false);
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.clearTimers();
        this.busy = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('is-busy');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    customElements.define('nw-form-status', NwFormStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abortController = new AbortController();
      if (this.querySelector('[data-recommendations-track]')) {
        this.dataset.loaded = 'true';
        this.setupSlider();
        return;
      }
      this.observeAndLoad();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.loadObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.abortController?.abort();
      this.sliderReady = false;
      this.interactionPaused = false;
      delete this.dataset.sliderReady;
      delete this.dataset.initialized;
    }

    observeAndLoad() {
      this.loadObserver = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          this.loadObserver.disconnect();
          this.loadRecommendations();
        },
        { rootMargin: '400px' },
      );
      this.loadObserver.observe(this);
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const source = html.querySelector('product-recommendations');
        const currentProductHandle = this.dataset.currentProductHandle;
        source?.querySelectorAll('[data-recommendations-item]').forEach((item) => {
          if (item.dataset.productHandle === currentProductHandle) item.remove();
        });
        const sourceTrack = source?.querySelector('[data-recommendations-track]');
        if (!sourceTrack?.querySelector('[data-recommendations-item]')) {
          this.remove();
          return;
        }
        this.innerHTML = source.innerHTML;
        this.dataset.loaded = 'true';
        this.setupSlider();
      } catch (error) {
        if (error.name !== 'AbortError') this.remove();
      }
    }

    setupSlider() {
      if (this.sliderReady) return;
      this.sliderReady = true;
      this.viewport = this.querySelector('[data-recommendations-viewport]');
      this.track = this.querySelector('[data-recommendations-track]');
      this.items = [...this.querySelectorAll('[data-recommendations-item]')];
      if (!this.viewport || !this.track || this.items.length === 0) return;
      this.activeIndex = 0;
      this.dataset.activeRecommendation = '1';
      this.dataset.sliderReady = 'true';

      /* Nativer Scroll uebernimmt Touch/Trackpad/Wheel selbst; eigene Touch-Handler entfallen. */
      this.addEventListener('pointerenter', () => this.pauseForInteraction(), {
        signal: this.abortController.signal,
      });
      this.addEventListener('pointerleave', () => this.resumeAfterInteraction(), {
        signal: this.abortController.signal,
      });
      this.addEventListener('focusin', () => this.pauseForInteraction(), {
        signal: this.abortController.signal,
      });
      this.addEventListener(
        'focusout',
        (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeAfterInteraction();
        },
        { signal: this.abortController.signal },
      );
      this.addEventListener('submit', (event) => this.handleQuickAdd(event), {
        signal: this.abortController.signal,
      });
      document.addEventListener('visibilitychange', () => this.updateAutoplay(), {
        signal: this.abortController.signal,
      });
      this.reducedMotion.addEventListener('change', () => this.handleMotionPreference(), {
        signal: this.abortController.signal,
      });

      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          this.isVisible = entry?.isIntersecting;
          this.updateAutoplay();
        },
        { threshold: 0.25 },
      );
      this.visibilityObserver.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.updateScrollableState());
      this.resizeObserver.observe(this.viewport);
      this.updateScrollableState();
      window.requestAnimationFrame(() => {
        this.updateScrollableState();
        const rect = this.getBoundingClientRect();
        this.isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        this.updateAutoplay();
      });
      this.handleMotionPreference();
    }

    move(direction) {
      this.hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 4;
      if (this.items.length < 2 || !this.hasOverflow) return;
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const firstOffset = this.items[0].offsetLeft;
      const nextIndex = (this.activeIndex + direction + this.items.length) % this.items.length;
      const target = Math.min(this.items[nextIndex].offsetLeft - firstOffset, maxScroll);
      this.activeIndex = nextIndex;
      this.dataset.activeRecommendation = String(nextIndex + 1);
      this.viewport.scrollTo({ left: target, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }

    pauseForInteraction() {
      this.interactionPaused = true;
      this.stopAutoplay();
    }

    resumeAfterInteraction() {
      this.interactionPaused = false;
      this.updateAutoplay();
    }

    handleMotionPreference() {
      this.updateAutoplay();
    }

    updateScrollableState() {
      this.hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 4;
      if (!this.hasOverflow) {
        this.activeIndex = 0;
        this.dataset.activeRecommendation = '1';
      }
      this.updateAutoplay();
    }

    updateAutoplay() {
      this.hasOverflow = this.viewport?.scrollWidth > this.viewport?.clientWidth + 4;
      const shouldRun =
        this.dataset.autoplay === 'true' &&
        this.items.length > 1 &&
        this.hasOverflow &&
        this.isVisible &&
        !this.interactionPaused &&
        !this.reducedMotion.matches &&
        !document.hidden;
      if (shouldRun) this.startAutoplay();
      else this.stopAutoplay();
    }

    startAutoplay() {
      if (this.autoplayTimer) return;
      const delay = Math.max(2500, Number(this.dataset.autoplayDelay) || 4500);
      this.autoplayTimer = window.setInterval(() => this.move(1), delay);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    async handleQuickAdd(event) {
      const form = event.target.closest('.product-card__form');
      if (!form || form.dataset.ready === 'true') return;
      event.preventDefault();
      const button = form.querySelector('button');
      const status = this.querySelector('[data-recommendations-status]');
      if (!button || button.disabled) return;
      button.disabled = true;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
      try {
        const formData = new FormData(form);
        if (window.nusswahnCartSectionId) {
          formData.append('sections', window.nusswahnCartSectionId);
          formData.append('sections_url', window.location.pathname);
        }
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        document.dispatchEvent(new CustomEvent('product:added', { detail: result }));
      } catch (error) {
        console.error(error);
        if (status) {
          status.textContent = this.dataset.quickAddError;
          status.hidden = false;
        }
      } finally {
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-whitelabel-nusswahn"] && !Shopify.designMode) return;
  try {
    
  /*
   * Gemeinsamer Formularzustand für Newsletter, Kontakt und die beiden B2B-Anfragen.
   * Aufgaben: Erfolgs-/Fehlermeldung nach dem Laden in eine echte Live-Region schreiben,
   * beim Absenden einen kurzen Busy-Zustand zeigen und Doppelabsendungen verhindern.
   */
  if (!customElements.get('nw-form-status')) {
    class NwFormStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.timers = [];
        this.busy = false;
        this.form = this.querySelector('form');
        this.announcer = this.querySelector('[data-form-announcer]');
        this.submitButton = this.querySelector('[data-form-submit]');

        this.onSubmit = this.handleSubmit.bind(this);
        this.onPageShow = this.handlePageShow.bind(this);

        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        window.addEventListener('pageshow', this.onPageShow);

        this.announceRenderedMessage();
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        window.removeEventListener('pageshow', this.onPageShow);
        this.clearTimers();
        this.dataset.initialized = 'false';
      }

      clearTimers() {
        (this.timers || []).forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
      }

      defer(callback, delay) {
        this.timers.push(window.setTimeout(callback, delay));
      }

      /*
       * Eine Live-Region kündigt Inhalte, die bereits beim Seitenaufbau darin stehen,
       * nicht an. Der sichtbare Text bleibt deshalb statisch und wird kurz nach dem
       * Laden zusätzlich in die leere Live-Region geschrieben.
       */
      announce(message, autoClear) {
        if (!this.announcer || !message) return;
        this.announcer.textContent = '';
        this.defer(() => {
          this.announcer.textContent = message;
        }, 160);
        if (autoClear) {
          this.defer(() => {
            this.announcer.textContent = '';
          }, 6000);
        }
      }

      announceRenderedMessage() {
        const message = this.querySelector('[data-form-message]');
        if (!message) return;
        this.announce(message.textContent.replace(/\s+/g, ' ').trim(), true);
      }

      handleSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }
        this.busy = true;
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) timeoutHint.hidden = true;
        this.announce(this.dataset.sendingMessage, false);
        if (!this.submitButton) return;
        this.submitButton.classList.add('is-busy');
        this.submitButton.setAttribute('aria-busy', 'true');
        // Erst nach dem Absenden sperren, damit der Request vollständig abgeht.
        this.defer(() => {
          this.submitButton.disabled = true;
        }, 0);
        this.watchSubmission();
      }

      /*
       * Shopify schickt das Formular erst ab, wenn hCaptcha ein Token geliefert hat, und
       * lädt dann die Seite neu. Bleibt beides aus (Captcha-Skript blockiert, Challenge
       * weggeklickt, Netzwerkfehler), zeigte der Button sonst endlos „Wird gesendet“
       * (Kundenmeldung 16. September 2026, Chrome unter Windows). Solange eine sichtbare
       * Challenge offen ist, warten wir; sonst gibt ein Timeout den Button wieder frei und
       * zeigt den Hinweis aus [data-form-timeout] beziehungsweise data-timeout-message.
       */
      watchSubmission() {
        const limit = Number(this.dataset.submitTimeout) || 15000;
        const graceAfterChallenge = 4000;
        let deadline = Date.now() + limit;
        const tick = () => {
          if (!this.busy) return;
          if (this.hasOpenChallenge()) {
            deadline = Date.now() + graceAfterChallenge;
          } else if (Date.now() >= deadline) {
            this.releaseSubmit();
            return;
          }
          this.defer(tick, 500);
        };
        this.defer(tick, 500);
      }

      hasOpenChallenge() {
        return [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((frame) => {
          const rect = frame.getBoundingClientRect();
          return rect.width > 100 && rect.height > 100 && getComputedStyle(frame).visibility !== 'hidden';
        });
      }

      releaseSubmit() {
        this.busy = false;
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('is-busy');
          this.submitButton.removeAttribute('aria-busy');
        }
        const timeoutHint = this.querySelector('[data-form-timeout]');
        if (timeoutHint) {
          timeoutHint.hidden = false;
          this.announce(timeoutHint.textContent.replace(/\s+/g, ' ').trim(), false);
        } else if (this.dataset.timeoutMessage) {
          this.announce(this.dataset.timeoutMessage, false);
        }
      }

      handlePageShow(event) {
        if (!event.persisted) return;
        this.clearTimers();
        this.busy = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('is-busy');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    customElements.define('nw-form-status', NwFormStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductView extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        this.setupProductVideos();
        return;
      }
      this.dataset.initialized = 'true';
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      this.form = this.querySelector('[data-product-form]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.setupMobileGallery();
      this.setupProductVideos();
      this.setupStickyAtc();
      // Die Optionsauswahl besteht seit dem 2. August 2026 aus Radios statt eines Selects.
      // Pro Option liegen mehrere Eingaben vor, deshalb wird nach Position gruppiert.
      this.optionInputs = [...this.querySelectorAll('[data-option-position]')];
      this.optionPositions = [
        ...new Set(this.optionInputs.map((input) => Number(input.dataset.optionPosition))),
      ].sort((a, b) => a - b);
      this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
      this.setupBoxVariantSelector();
      this.setupBoxJump();
      this.setupQuantity();
      this.querySelectorAll('[data-media-target]').forEach((button) =>
        button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget)),
      );
      this.querySelectorAll('[data-quantity-change]').forEach((button) =>
        button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange))),
      );
      this.form?.addEventListener('submit', (event) => this.addToCart(event));
    }

    disconnectedCallback() {
      window.clearTimeout(this.submitStateTimer);
      window.clearTimeout(this.boxFocusTimer);
      if (this.handleProductVideoClick) {
        this.removeEventListener('click', this.handleProductVideoClick);
      }
      if (this.handleProductVideoState) {
        this.removeEventListener('play', this.handleProductVideoState, true);
        this.removeEventListener('pause', this.handleProductVideoState, true);
      }
      if (this.productVideoMotionQuery && this.handleProductVideoMotionChange) {
        this.productVideoMotionQuery.removeEventListener('change', this.handleProductVideoMotionChange);
      }
      this.querySelectorAll('[data-product-video-toggle] video').forEach((video) => video.pause());
    }

    setupProductVideos() {
      if (!this.querySelector('[data-product-video-toggle] video')) return;
      this.productVideoMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleProductVideoClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const toggle = event.target.closest('[data-product-video-toggle]');
        if (!toggle || !this.contains(toggle)) return;
        const video = toggle.querySelector('video');
        if (!video) return;
        if (video.paused || video.ended) {
          video.play().catch(() => this.updateProductVideoState(video));
        } else {
          video.pause();
        }
      };
      this.handleProductVideoState = (event) => {
        if (event.target instanceof HTMLVideoElement) {
          this.updateProductVideoState(event.target);
        }
      };
      this.handleProductVideoMotionChange = () => this.updateProductVideoPlayback();
      this.addEventListener('click', this.handleProductVideoClick);
      this.addEventListener('play', this.handleProductVideoState, true);
      this.addEventListener('pause', this.handleProductVideoState, true);
      this.productVideoMotionQuery.addEventListener('change', this.handleProductVideoMotionChange);
      this.updateProductVideoPlayback();
    }

    updateProductVideoState(video) {
      const toggle = video.closest('[data-product-video-toggle]');
      if (!toggle) return;
      const isPlaying = !video.paused && !video.ended;
      toggle.setAttribute('aria-pressed', String(isPlaying));
      toggle.setAttribute(
        'aria-label',
        isPlaying ? toggle.dataset.videoPauseLabel : toggle.dataset.videoPlayLabel,
      );
    }

    updateProductVideoPlayback() {
      const reduceMotion = this.productVideoMotionQuery?.matches === true;
      this.querySelectorAll('[data-product-video-toggle]').forEach((toggle) => {
        const video = toggle.querySelector('video');
        if (!video) return;
        const active = toggle.closest('[data-media-id]')?.classList.contains('is-active') === true;
        if (active && !reduceMotion) {
          video.play().catch(() => this.updateProductVideoState(video));
        } else if (!active || reduceMotion) {
          video.pause();
        }
        this.updateProductVideoState(video);
      });
    }

    setupBoxVariantSelector() {
      this.boxVariantSelect = this.querySelector('[data-box-variant-select]');
      this.boxVariantStatus = this.querySelector('[data-box-variant-status]');
      this.boxVariantUi = this.querySelector('[data-box-variant-selector-ui]');
      this.boxInlineTotal = this.querySelector('[data-box-inline-total-weight]');
      this.boxInlineTotalPending = this.boxInlineTotal?.textContent.trim() || '';
      if (!this.boxVariantSelect) return;
      this.boxVariantSelect.required = false;
      this.submitLocked = true;
      this.restoreSubmitButtons();
      this.boxVariantSelect.addEventListener('change', () => this.updateBoxVariant(this.boxVariantSelect.value));
      this.querySelectorAll('[data-box-variant-id]').forEach((button) => {
        button.addEventListener('click', () => this.updateBoxVariant(button.dataset.boxVariantId));
      });
    }

    setupBoxJump() {
      this.querySelectorAll('[data-box-jump]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          if (trigger.getAttribute('aria-disabled') === 'true') return;
          this.jumpToBoxSelection();
        });
      });
    }

    jumpToBoxSelection() {
      const target = document.querySelector(
        `box-product-selector[data-product-id="${CSS.escape(this.dataset.productId)}"]`,
      );
      if (!target) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      const choice = target.querySelector('[data-box-choice]:not([disabled])');
      if (!choice) return;
      window.clearTimeout(this.boxFocusTimer);
      this.boxFocusTimer = window.setTimeout(
        () => choice.focus({ preventScroll: true }),
        reduced ? 0 : 420,
      );
    }

    restoreSubmitButtons() {
      const disabled = this.submitLocked === true;
      this.querySelectorAll('[data-product-submit], [data-sticky-submit]').forEach((button) => {
        button.disabled = disabled;
      });
    }

    setSubmitState(state) {
      this.querySelectorAll('[data-product-submit], [data-sticky-submit]').forEach((button) => {
        button.classList.toggle('is-busy', state === 'busy');
        button.classList.toggle('is-done', state === 'done');
        button.classList.toggle('is-error', state === 'error');
        if (state === 'busy') {
          button.setAttribute('aria-busy', 'true');
        } else {
          button.removeAttribute('aria-busy');
        }
      });
    }

    setStickyStatus(message) {
      const stickyStatus = this.querySelector('[data-sticky-status]');
      if (!stickyStatus) return;
      stickyStatus.textContent = message || '';
      stickyStatus.hidden = !message;
    }

    setupQuantity() {
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.quantityDial = this.querySelector('[data-quantity-dial]');
      this.quantityStatus = this.querySelector('[data-quantity-status]');
      if (!this.quantityInput || !this.quantityDial) return;
      this.quantityValue = this.normalizeQuantity(this.quantityInput.value);
      this.quantityInput.value = this.quantityValue;
      this.renderQuantity(this.quantityValue);
      this.quantityInput.addEventListener('input', () => {
        if (this.quantityDispatching) return;
        if (this.quantityInput.value === '') return;
        const nextValue = this.normalizeQuantity(this.quantityInput.value);
        const direction = Math.sign(nextValue - this.quantityValue);
        this.quantityValue = nextValue;
        this.renderQuantity(nextValue, direction);
      });
      this.quantityInput.addEventListener('change', () => {
        const nextValue = this.normalizeQuantity(this.quantityInput.value);
        this.quantityInput.value = nextValue;
        this.quantityValue = nextValue;
        this.renderQuantity(nextValue);
        this.announceQuantity(nextValue);
      });
    }

    normalizeQuantity(value) {
      const input = this.quantityInput;
      const min = Number.isFinite(Number(input?.min)) && input.min !== '' ? Number(input.min) : 1;
      const max = Number.isFinite(Number(input?.max)) && input.max !== '' ? Number(input.max) : Number.POSITIVE_INFINITY;
      const step = Number.isFinite(Number(input?.step)) && input.step !== '' && input.step !== 'any' ? Number(input.step) : 1;
      const parsed = Number(value);
      const safeValue = Number.isFinite(parsed) ? parsed : min;
      const steppedValue = min + Math.round((safeValue - min) / step) * step;
      return Math.min(max, Math.max(min, Number(steppedValue.toFixed(6))));
    }

    renderQuantity(value, direction = 0) {
      if (!this.quantityDial) return;
      const current = this.quantityDial.querySelector('[data-quantity-display]');
      const currentValue = this.quantityDial.dataset.value || current?.textContent.trim();
      const nextValue = String(value);
      this.quantityDial.dataset.value = nextValue;
      if (!current || currentValue === nextValue || direction === 0) {
        this.quantityDial.replaceChildren(this.createQuantityValue(nextValue));
        return;
      }

      this.quantityAnimationId = (this.quantityAnimationId || 0) + 1;
      const animationId = this.quantityAnimationId;
      this.quantityDial.querySelectorAll('.quantity__dial-value').forEach((element) => {
        element.getAnimations().forEach((animation) => animation.cancel());
      });

      const outgoing = this.createQuantityValue(currentValue);
      const incoming = this.createQuantityValue(nextValue);
      this.quantityDial.replaceChildren(outgoing, incoming);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.quantityDial.replaceChildren(incoming);
        return;
      }

      if (typeof outgoing.animate !== 'function' || typeof incoming.animate !== 'function') {
        this.quantityDial.replaceChildren(incoming);
        return;
      }

      const movingUp = direction > 0;
      const outgoingEnd = movingUp
        ? { transform: 'translateY(-92%) rotateX(-72deg)', opacity: 0 }
        : { transform: 'translateY(92%) rotateX(72deg)', opacity: 0 };
      const incomingStart = movingUp
        ? { transform: 'translateY(92%) rotateX(72deg)', opacity: 0 }
        : { transform: 'translateY(-92%) rotateX(-72deg)', opacity: 0 };
      const timing = { duration: 430, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' };
      const outgoingAnimation = outgoing.animate(
        [{ transform: 'translateY(0) rotateX(0)', opacity: 1 }, outgoingEnd],
        timing,
      );
      const incomingAnimation = incoming.animate(
        [incomingStart, { transform: 'translateY(0) rotateX(0)', opacity: 1 }],
        timing,
      );

      let animationFinished = false;
      const finishAnimation = () => {
        if (animationFinished) return;
        animationFinished = true;
        if (this.quantityAnimationId !== animationId) return;
        this.quantityDial.replaceChildren(this.createQuantityValue(nextValue));
      };
      Promise.allSettled([outgoingAnimation.finished, incomingAnimation.finished]).then(finishAnimation);
      window.setTimeout(finishAnimation, timing.duration + 80);
    }

    createQuantityValue(value) {
      const element = document.createElement('span');
      element.className = 'quantity__dial-value';
      element.dataset.quantityDisplay = '';
      element.textContent = value;
      return element;
    }

    announceQuantity(value) {
      if (!this.quantityStatus) return;
      this.quantityStatus.textContent = this.quantityStatus.dataset.quantityTemplate.replace(
        '__quantity__',
        String(value),
      );
    }

    showMedia(id, options = {}) {
      const button = this.querySelector(`[data-media-target="${CSS.escape(id)}"]`);
      const media = this.querySelector(`[data-media-id="${CSS.escape(id)}"]`);
      const index = Number(button?.dataset.mediaIndex ?? media?.dataset.mediaIndex ?? 0);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile && !options.preserveScroll) {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        media?.scrollIntoView({ behavior, block: 'nearest', inline: 'center' });
      } else {
        this.querySelector('[data-media-track]')?.style.setProperty('--media-index', index);
      }
      this.updateMediaState(id, index);
    }

    updateMediaState(id, index) {
      const previousMediaId = this.querySelector('[data-media-id].is-active')?.dataset.mediaId;
      this.querySelectorAll('[data-media-id]').forEach((media) => {
        const isActive = media.dataset.mediaId === id;
        media.classList.toggle('is-active', isActive);
        media.setAttribute('aria-hidden', String(!isActive));
        media.toggleAttribute('inert', !isActive);
      });
      this.querySelectorAll('[data-media-target]').forEach((mediaButton) => {
        const isActive = mediaButton.dataset.mediaTarget === id;
        mediaButton.classList.toggle('is-active', isActive);
        mediaButton.setAttribute('aria-pressed', String(isActive));
      });
      const status = this.querySelector('[data-gallery-status]');
      if (status) {
        status.textContent = status.dataset.statusTemplate
          .replace('__current__', String(index + 1))
          .replace('__total__', String(this.querySelectorAll('[data-media-id]').length));
      }
      if (previousMediaId !== id) {
        this.updateProductVideoPlayback();
      }
    }

    setupMobileGallery() {
      const stage = this.querySelector('.product-gallery__stage');
      const mediaItems = [...this.querySelectorAll('[data-media-id]')];
      if (!stage || mediaItems.length < 2) return;
      // Endlos in beide Richtungen: hinter dem letzten Bild kommt wieder das erste.
      // Der Stups am rechten Pfeil hat seinen Zweck erfüllt, sobald einmal
      // geblättert wurde; danach wäre er nur noch Unruhe neben dem Kauftext.
      const shell = this.querySelector('.product-gallery__stage-shell');
      const markExplored = () => shell?.classList.add('is-explored');
      const stepMedia = (direction) => {
        const activeIndex = mediaItems.findIndex((media) => media.classList.contains('is-active'));
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.showMedia(mediaItems[nextIndex].dataset.mediaId);
      };
      this.querySelector('[data-media-prev]')?.addEventListener('click', () => stepMedia(-1));
      this.querySelector('[data-media-next]')?.addEventListener('click', () => stepMedia(1));
      stage.addEventListener('scroll', markExplored, { passive: true, once: true });
      let scrollTimer;
      stage.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;
            const stageCenter = stage.getBoundingClientRect().left + stage.clientWidth / 2;
            const activeMedia = mediaItems.reduce((closest, media) => {
              const mediaRect = media.getBoundingClientRect();
              const distance = Math.abs(mediaRect.left + mediaRect.width / 2 - stageCenter);
              return distance < closest.distance ? { media, distance } : closest;
            }, { media: mediaItems[0], distance: Number.POSITIVE_INFINITY }).media;
            this.updateMediaState(activeMedia.dataset.mediaId, Number(activeMedia.dataset.mediaIndex));
          }, 80);
        },
        { passive: true },
      );
    }

    setupStickyAtc() {
      const stickyAtc = this.querySelector('[data-sticky-atc]');
      const mainSubmit = this.querySelector('[data-product-submit]');
      if (!stickyAtc || !mainSubmit) return;
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let submitEntry;
      const updateStickyAtc = () => {
        const shouldShow =
          mobileQuery.matches &&
          submitEntry &&
          !submitEntry.isIntersecting &&
          submitEntry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', Boolean(shouldShow));
        stickyAtc.setAttribute('aria-hidden', String(!shouldShow));
        stickyAtc.toggleAttribute('inert', !shouldShow);
      };
      new IntersectionObserver(([entry]) => {
        submitEntry = entry;
        updateStickyAtc();
      }).observe(mainSubmit);
      mobileQuery.addEventListener('change', updateStickyAtc);
    }

    changeQuantity(change) {
      const input = this.quantityInput || this.querySelector('input[name="quantity"]');
      if (!input) return;
      const step = Number.isFinite(Number(input.step)) && input.step !== '' && input.step !== 'any' ? Number(input.step) : 1;
      const currentValue = this.normalizeQuantity(input.value);
      const nextValue = this.normalizeQuantity(currentValue + change * step);
      if (nextValue === currentValue) return;
      input.value = nextValue;
      this.quantityValue = nextValue;
      this.renderQuantity(nextValue, Math.sign(change));
      this.announceQuantity(nextValue);
      this.quantityDispatching = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityDispatching = false;
    }

    /*
     * Preise beim Variantenwechsel müssen exakt so aussehen wie die serverseitig gerenderten.
     * `Intl.NumberFormat` schreibt für Deutsch "13,95 €", der Liquid-money-Filter dagegen "€13,95";
     * beim Umschalten sprang deshalb nicht nur der Betrag, sondern auch die Schreibweise.
     * Deswegen wird hier `shop.money_format` nachgebildet statt neu formatiert.
     */
    money(cents) {
      const format = String(window.nusswahnMoneyFormat || '').replace(/<[^>]*>/g, '');
      const value = Number(cents) || 0;

      const withDelimiters = (precision, thousands, decimal) => {
        const fixed = (value / 100).toFixed(precision);
        const [whole, fraction] = fixed.split('.');
        const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        return fraction ? `${grouped}${decimal}${fraction}` : grouped;
      };

      const rendered = format.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, placeholder) => {
        switch (placeholder) {
          case 'amount':
            return withDelimiters(2, ',', '.');
          case 'amount_no_decimals':
            return withDelimiters(0, ',', '.');
          case 'amount_with_comma_separator':
            return withDelimiters(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return withDelimiters(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return withDelimiters(2, "'", '.');
          case 'amount_with_space_separator':
            return withDelimiters(2, ' ', ',');
          case 'amount_no_decimals_with_space_separator':
            return withDelimiters(0, ' ', ',');
          default:
            return match;
        }
      });

      // Fehlt das Shop-Format, bleibt wenigstens ein lesbarer Betrag statt einer leeren Zeile.
      return rendered || withDelimiters(2, '.', ',');
    }

    /*
     * Preiswechsel als kurzer Crossfade statt hartem Sprung: reduzierte Fassung des
     * Quantity-Dial-Musters, ohne Rotation. Der Timer je Element verhindert, dass sich
     * schnelle Variantenwechsel gegenseitig überholen.
     */
    swapPriceText(element, nextText) {
      if (!element || element.textContent === nextText) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.textContent = nextText;
        return;
      }
      window.clearTimeout(element.priceSwapTimer);
      element.classList.add('is-price-swapping');
      element.priceSwapTimer = window.setTimeout(() => {
        element.textContent = nextText;
        element.classList.remove('is-price-swapping');
      }, 110);
    }

    updatePrice(variant) {
      this.querySelectorAll('[data-current-price]').forEach((element) => {
        this.swapPriceText(element, this.money(variant.price));
      });
      this.swapPriceText(this.querySelector('[data-sticky-price]'), this.money(variant.price));

      const unitPrice = this.querySelector('[data-unit-price]');
      if (unitPrice && variant.unit_price && variant.unit_price_measurement) {
        const measurement = variant.unit_price_measurement;
        const referenceValue = Number(measurement.reference_value) || 1;
        const referenceUnit = String(measurement.reference_unit || '').toLowerCase();
        const pricePerKilogram = referenceUnit === 'g'
          ? Math.round((Number(variant.unit_price) * 1000) / referenceValue)
          : Number(variant.unit_price);
        const unitText = referenceUnit === 'g'
          ? `${this.money(pricePerKilogram)} / 1 kg`
          : `${this.money(pricePerKilogram)} / ${referenceValue} ${measurement.reference_unit}`;
        // Aus dem Verborgenen kommend gibt es nichts zu überblenden.
        if (unitPrice.hidden) {
          unitPrice.textContent = unitText;
        } else {
          this.swapPriceText(unitPrice, unitText);
        }
        unitPrice.hidden = false;
      } else if (unitPrice) {
        unitPrice.hidden = true;
      }

      const comparePrice = this.querySelector('[data-compare-price]');
      if (comparePrice) {
        const compareText = variant.compare_at_price ? this.money(variant.compare_at_price) : '';
        const compareHidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
        if (comparePrice.hidden || compareHidden) {
          comparePrice.textContent = compareText;
        } else {
          this.swapPriceText(comparePrice, compareText);
        }
        comparePrice.hidden = compareHidden;
      }

      /*
       * Die Ersparnis wird neu gerechnet statt nur ein- und ausgeblendet: Zwischen zwei
       * Varianten kann sich der Prozentsatz ändern, ohne dass der Rabatt verschwindet.
       * Gleiche Rundung wie in snippets/price.liquid, damit der erste Aufbau der Seite
       * und jeder Wechsel danach dieselbe Zahl zeigen.
       */
      const saving = this.querySelector('[data-price-saving]');
      if (saving) {
        const compareAt = variant.compare_at_price;
        const percent =
          compareAt && compareAt > variant.price
            ? Math.round(((compareAt - variant.price) / compareAt) * 100)
            : 0;
        const savingText =
          percent > 0 ? saving.dataset.savingTemplate.replace('__percent__', percent) : '';
        if (saving.hidden || percent <= 0) {
          saving.textContent = savingText;
        } else {
          this.swapPriceText(saving, savingText);
        }
        saving.hidden = percent <= 0;
      }
    }

    updateVariant() {
      // Positionen sind aufsteigend sortiert und decken sich damit mit variant.options.
      const options = this.optionPositions.map((position) => {
        const gruppe = this.optionInputs.filter(
          (input) => Number(input.dataset.optionPosition) === position,
        );
        const gewaehlt = gruppe.find((input) => input.checked) ?? gruppe[0];
        return gewaehlt?.value;
      });
      const variant = this.variants.find((candidate) =>
        candidate.options.every((option, index) => option === options[index]),
      );
      if (!variant) return;
      this.applyVariant(variant);
    }

    updateBoxVariant(variantId) {
      const variant = this.variants.find((candidate) => String(candidate.id) === String(variantId));
      if (!variant) return;
      this.boxVariantSelect.value = variant.id;
      let selectedButton = null;
      let shouldPulse = false;
      this.querySelectorAll('[data-box-variant-id]').forEach((button) => {
        const isSelected = button.dataset.boxVariantId === String(variant.id);
        if (isSelected) {
          selectedButton = button;
          shouldPulse = button.getAttribute('aria-pressed') !== 'true';
        }
        button.setAttribute('aria-pressed', String(isSelected));
      });
      const totalWeightLabel = this.updateBoxWeightSummary();
      if (this.boxVariantStatus) {
        const template = totalWeightLabel
          ? this.boxVariantStatus.dataset.selectedWeightTemplate
          : this.boxVariantStatus.dataset.selectedTemplate;
        this.boxVariantStatus.textContent = template
          .replace('__variant__', variant.title)
          .replace('__weight__', totalWeightLabel || '');
      }
      if (selectedButton && shouldPulse) this.pulseBoxVariantChoice(selectedButton);
      this.querySelectorAll('[data-box-atc-hint]').forEach((hint) => {
        const template = hint.dataset.selectedTemplate;
        hint.textContent = template ? template.replace('__variant__', variant.title) : variant.title;
        hint.setAttribute('aria-disabled', 'true');
        hint.tabIndex = -1;
        hint.removeAttribute('data-box-jump');
      });
      this.applyVariant(variant, { preserveScroll: true });
    }

    updateBoxWeightSummary() {
      const fixedWeight = Number(this.boxVariantUi?.dataset.fixedWeightGrams);
      const selectedWeight = Number(
        this.boxVariantSelect.selectedOptions[0]?.dataset.boxFillWeightGrams,
      );
      if (!Number.isFinite(fixedWeight) || !Number.isFinite(selectedWeight)) {
        if (this.boxInlineTotal) this.boxInlineTotal.textContent = this.boxInlineTotalPending;
        return '';
      }
      const totalWeightLabel = this.formatBoxWeight(fixedWeight + selectedWeight);
      if (this.boxInlineTotal) this.boxInlineTotal.textContent = totalWeightLabel;
      return totalWeightLabel;
    }

    formatBoxWeight(grams) {
      if (grams < 1000) return `${Math.round(grams).toLocaleString('de-DE')} g`;
      return `${new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(grams / 1000)} kg`;
    }

    pulseBoxVariantChoice(button) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      button.removeAttribute('data-selection-pulse');
      void button.offsetWidth;
      button.dataset.selectionPulse = 'true';
      const visual = button.querySelector('.box-variant-selector__visual');
      visual?.addEventListener('animationend', () => button.removeAttribute('data-selection-pulse'), {
        once: true,
      });
    }

    applyVariant(variant, options = {}) {
      this.variantInput.value = variant.id;
      this.updatePrice(variant);
      this.submitLocked = !variant.available;
      this.restoreSubmitButtons();
      this.querySelectorAll('[data-add-label]').forEach((label) => {
        label.textContent = variant.available ? window.nusswahnAddToCart : window.nusswahnSoldOut;
      });
      this.querySelectorAll('[data-product-notify]').forEach((notify) => {
        notify.hidden = variant.available;
      });
      this.querySelectorAll('[data-notify-variant]').forEach((field) => {
        const template = field.dataset.notifyTemplate;
        if (template) field.value = template.replace('__variant__', variant.title);
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const featuredMediaId = variant.featured_media ? String(variant.featured_media.id) : '';
      if (featuredMediaId && this.querySelector(`[data-media-id="${CSS.escape(featuredMediaId)}"]`)) {
        this.showMedia(featuredMediaId, { preserveScroll: options.preserveScroll === true });
      }
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.boxVariantSelect && !this.boxVariantSelect.value) {
        const status = this.querySelector('[data-product-status]');
        if (this.boxVariantStatus) {
          this.boxVariantStatus.textContent = this.boxVariantStatus.dataset.requiredMessage;
        }
        if (status) {
          status.classList.remove('is-error');
          status.textContent = '';
        }
        this.setStickyStatus('');
        const inlineChoice = this.querySelector('[data-box-variant-id]:not([disabled])');
        if (inlineChoice) {
          inlineChoice.focus();
        } else {
          // Auswahl liegt in der eigenen Section: dorthin führen statt still zu scheitern.
          this.jumpToBoxSelection();
        }
        return;
      }
      if (this.addToCartPending) return;
      this.addToCartPending = true;
      const status = this.querySelector('[data-product-status]');
      window.clearTimeout(this.submitStateTimer);
      // Haupt- und Sticky-Button gemeinsam sperren, sonst sind Doppel-Adds möglich.
      this.querySelectorAll('[data-product-submit], [data-sticky-submit]').forEach((button) => {
        button.disabled = true;
      });
      this.setSubmitState('busy');
      this.setStickyStatus('');
      if (status) {
        status.classList.remove('is-error');
        status.textContent = status.dataset.busyMessage || '';
      }
      try {
        const formData = new FormData(this.form);
        if (window.nusswahnCartSectionId) {
          formData.append('sections', window.nusswahnCartSectionId);
          formData.append('sections_url', window.location.pathname);
        }
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        document.dispatchEvent(new CustomEvent('product:added', { detail: result }));
        this.setSubmitState('done');
        if (status) {
          status.classList.remove('is-error');
          status.textContent = status.dataset.addedMessage || '';
        }
      } catch (error) {
        // Die API-Rohmeldung ist englisch und für Kundinnen unbrauchbar.
        console.error(error);
        const message = status?.dataset.errorMessage || '';
        this.setSubmitState('error');
        if (status) {
          status.classList.add('is-error');
          status.textContent = message;
        }
        this.setStickyStatus(message);
      } finally {
        this.addToCartPending = false;
        this.restoreSubmitButtons();
        this.submitStateTimer = window.setTimeout(() => this.setSubmitState('idle'), 1600);
      }
    }
  }

  if (!customElements.get('product-view')) customElements.define('product-view', ProductView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel-nusswahn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nusswahn-reviews')) {
    customElements.define(
      'nusswahn-reviews',
      class extends HTMLElement {
        connectedCallback() {
          // Judge.me rendert das Carousel erst nach dem Laden und tauscht beim Blättern
          // Karten aus. Einmal aufräumen reicht deshalb nicht, wir beobachten den Baum.
          this.markAnonymous = this.markAnonymous.bind(this);
          this.observer = new MutationObserver(this.markAnonymous);
          this.observer.observe(this, { childList: true, subtree: true });
          this.markAnonymous();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        markAnonymous() {
          const platzhalter = ['anonymous', 'anonym'];
          this.querySelectorAll('.jdgm-carousel-item__reviewer-name').forEach((name) => {
            const text = name.textContent.trim().toLowerCase();
            name.classList.toggle('is-anonymous', platzhalter.includes(text));
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-collection-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-collection-slider')) {
    class ShopCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.rail = this.querySelector('[data-shop-collection-rail]');
        this.nextButton = this.querySelector('[data-shop-collection-next]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!this.rail || !this.nextButton) return;

        this.nextButton.addEventListener('click', () => this.advance(), { signal });
        this.rail.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.motionQuery.addEventListener('change', () => this.update(), { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.rail);
        }
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }

      update() {
        if (!this.rail) return;
        const maximumScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        this.toggleAttribute('data-can-scroll-forward', this.rail.scrollLeft < maximumScroll - 2);
      }

      advance() {
        const card = this.rail.querySelector('.shop-collection-band__card, .shop-collection-band__placeholder');
        const gap = Number.parseFloat(window.getComputedStyle(this.rail).gap) || 0;
        const distance = (card?.getBoundingClientRect().width || this.rail.clientWidth * 0.8) + gap;
        this.rail.scrollBy({
          left: distance,
          behavior: this.motionQuery.matches ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('shop-collection-slider', ShopCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-wheel-nusswahn"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-spin-wheel-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const configNode = dialog.querySelector('[data-spin-wheel-config]');
    let segments = [];
    try {
      segments = JSON.parse(configNode?.textContent || '[]');
    } catch (error) {
      return;
    }
    if (segments.length < 2) return;

    const SESSION_KEY = 'nusswahn:popup-session';
    const STORAGE_KEY = 'nusswahn:spin-wheel';
    const DAY = 86400000;
    const BLOCKED_TEMPLATES = ['cart', 'password'];
    const SPIN_MS = 4800;

    const disc = dialog.querySelector('[data-spin-wheel-disc]');
    const actions = dialog.querySelector('[data-spin-wheel-actions]');
    const result = dialog.querySelector('[data-spin-wheel-result]');
    const codeNode = dialog.querySelector('[data-spin-wheel-code]');
    const missNode = dialog.querySelector('[data-spin-wheel-miss]');
    const announcer = dialog.querySelector('[data-spin-wheel-announcer]');
    const spinButton = dialog.querySelector('[data-spin-wheel-spin]');
    const activateButton = dialog.querySelector('[data-spin-wheel-activate]');
    const copyButton = dialog.querySelector('[data-spin-wheel-copy]');
    const confetti = dialog.querySelector('[data-spin-wheel-confetti]');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const sliceSize = 360 / segments.length;
    let rotation = 0;
    let spinning = false;
    let missTimer = 0;

    const readState = () => {
      try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
      } catch (error) {
        return {};
      }
    };

    const writeState = (state) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (error) {
        // Privater Modus ohne Storage: Verhalten wie beim ersten Besuch.
      }
    };

    const claimSession = () => {
      try {
        if (window.sessionStorage.getItem(SESSION_KEY)) return false;
        window.sessionStorage.setItem(SESSION_KEY, 'wheel');
      } catch (error) {
        // Ohne Storage bleibt es beim Standardverhalten.
      }
      return true;
    };

    const point = (radius, angle) => {
      const rad = ((angle - 90) * Math.PI) / 180;
      return { x: 100 + radius * Math.cos(rad), y: 100 + radius * Math.sin(rad) };
    };

    const labelNodes = [];

    const buildDisc = () => {
      const ns = 'http://www.w3.org/2000/svg';
      // Der Platz je Beschriftung schrumpft mit der Segmentzahl und mit der Textlänge;
      // ohne Anpassung läuft ein langes Label über den Segmentrand hinaus.
      const longest = segments.reduce((max, item) => Math.max(max, String(item.label).length), 0);
      const base = segments.length > 5 ? 10 : 13;
      const fontSize = longest > 7 ? Math.max(8, base - Math.ceil((longest - 7) / 1.5)) : base;
      disc.textContent = '';
      labelNodes.length = 0;
      segments.forEach((segment, index) => {
        const start = index * sliceSize - sliceSize / 2;
        const end = start + sliceSize;
        const from = point(98, end);
        const to = point(98, start);
        const largeArc = sliceSize > 180 ? 1 : 0;

        const path = document.createElementNS(ns, 'path');
        path.setAttribute(
          'd',
          `M 100 100 L ${from.x} ${from.y} A 98 98 0 ${largeArc} 0 ${to.x} ${to.y} Z`,
        );
        path.setAttribute('fill', segment.color);
        path.setAttribute('stroke', '#fff');
        path.setAttribute('stroke-width', '2');
        disc.appendChild(path);

        const anchor = point(62, index * sliceSize);
        const label = document.createElementNS(ns, 'text');
        label.setAttribute('x', anchor.x);
        label.setAttribute('y', anchor.y);
        label.setAttribute('fill', segment.ink);
        label.setAttribute('font-size', fontSize);
        label.textContent = segment.label;
        disc.appendChild(label);
        labelNodes.push({ node: label, x: anchor.x, y: anchor.y });
      });
    };

    /*
     * Die Beschriftungen sitzen im Rad und drehen sich mit. Nach dem Auslaufen stünde etwa
     * die Hälfte auf dem Kopf, deshalb richten sie sich anschließend wieder auf. Der kurze
     * Übergang macht daraus einen sichtbaren Abschluss statt eines Sprungs.
     */
    const uprightLabels = () => {
      const deg = ((rotation % 360) + 360) % 360;
      labelNodes.forEach(({ node, x, y }) => {
        node.setAttribute('transform', `rotate(${-deg.toFixed(2)} ${x} ${y})`);
      });
    };

    // Gewichtungen sind relativ; ein Segment ohne Gewicht kann trotzdem nie gewinnen.
    const pickWinner = () => {
      const total = segments.reduce((sum, segment) => sum + Math.max(0, segment.weight), 0);
      if (total <= 0) return Math.floor(Math.random() * segments.length);
      let roll = Math.random() * total;
      for (let index = 0; index < segments.length; index += 1) {
        roll -= Math.max(0, segments[index].weight);
        if (roll < 0) return index;
      }
      return segments.length - 1;
    };

    const fireConfetti = () => {
      if (reducedMotion.matches || !confetti?.getContext) return;
      const box = dialog.querySelector('.nw-wheel__inner').getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;
      confetti.width = box.width * ratio;
      confetti.height = box.height * ratio;
      const ctx = confetti.getContext('2d');
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

      const palette = segments.map((segment) => segment.color);
      const pieces = Array.from({ length: 90 }, () => ({
        x: box.width * (0.3 + Math.random() * 0.4),
        y: box.height * 0.42,
        vx: (Math.random() - 0.5) * 8,
        vy: -Math.random() * 10 - 3,
        gravity: 0.3 + Math.random() * 0.16,
        size: 4 + Math.random() * 5,
        color: palette[Math.floor(Math.random() * palette.length)],
        angle: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.3,
        life: 0,
        span: 100 + Math.random() * 40,
      }));

      const tick = () => {
        ctx.clearRect(0, 0, box.width, box.height);
        let alive = false;
        pieces.forEach((piece) => {
          if (piece.life >= piece.span) return;
          alive = true;
          piece.life += 1;
          piece.x += piece.vx;
          piece.y += piece.vy;
          piece.vy += piece.gravity;
          piece.vx *= 0.995;
          piece.angle += piece.spin;
          const fade = piece.life > piece.span - 30 ? (piece.span - piece.life) / 30 : 1;
          ctx.save();
          ctx.translate(piece.x, piece.y);
          ctx.rotate(piece.angle);
          ctx.globalAlpha = Math.max(0, fade);
          ctx.fillStyle = piece.color;
          ctx.fillRect(-piece.size / 2, -piece.size * 0.4, piece.size, piece.size * 0.8);
          ctx.restore();
        });
        if (alive) {
          window.requestAnimationFrame(tick);
        } else {
          ctx.clearRect(0, 0, box.width, box.height);
        }
      };
      tick();
    };

    const showResult = (segment) => {
      writeState({ status: 'won', code: segment.code || '' });
      actions.hidden = true;
      result.hidden = false;
      codeNode.textContent = segment.code || segment.label;
      activateButton.hidden = !segment.code;
      copyButton.hidden = !segment.code;
      if (announcer) announcer.textContent = `${segment.label}. ${segment.code || ''}`.trim();
      fireConfetti();
    };

    const showMiss = (segment) => {
      missNode.hidden = false;
      if (announcer) announcer.textContent = missNode.textContent;
      window.clearTimeout(missTimer);
      missTimer = window.setTimeout(() => {
        missNode.hidden = true;
      }, 3200);
      // Ein Fehlversuch darf erneut gedreht werden, sonst ist das Rad eine Sackgasse.
      spinning = false;
      spinButton.disabled = false;
    };

    const spin = () => {
      if (spinning || !result.hidden) return;
      spinning = true;
      spinButton.disabled = true;
      missNode.hidden = true;

      const winner = pickWinner();
      const segment = segments[winner];
      const settle = () => {
        uprightLabels();
        if (segment.isMiss) showMiss(segment);
        else showResult(segment);
      };

      if (reducedMotion.matches) {
        disc.style.transition = 'none';
        rotation = -winner * sliceSize;
        disc.style.transform = `rotate(${rotation}deg)`;
        settle();
        return;
      }

      // Innerhalb des Segments leicht streuen, damit der Zeiger nicht immer mittig trifft.
      const jitter = (Math.random() - 0.5) * (sliceSize - 12);
      const target = -winner * sliceSize + jitter;
      const turns = 5 + Math.floor(Math.random() * 2);
      rotation += turns * 360 + (((target - (rotation % 360)) % 360) + 360) % 360;

      disc.style.transition = `transform ${SPIN_MS}ms cubic-bezier(0.16, 0.72, 0.14, 1)`;
      window.requestAnimationFrame(() => {
        disc.style.transform = `rotate(${rotation}deg)`;
      });
      window.setTimeout(settle, SPIN_MS + 120);
    };

    const open = () => {
      if (dialog.open) return;
      dialog.showModal();
      window.requestAnimationFrame(() => dialog.classList.add('is-open'));
    };

    const close = () => {
      if (!dialog.open) return;
      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      window.setTimeout(() => {
        dialog.classList.remove('is-closing');
        dialog.close();
      }, 220);
    };

    const dismiss = () => {
      const snooze = Number(dialog.dataset.snooze) || 30;
      const state = readState();
      if (state.status !== 'won') {
        writeState({ status: 'dismissed', until: Date.now() + snooze * DAY });
      }
      close();
    };

    buildDisc();

    dialog.querySelector('[data-spin-wheel-close]')?.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dismiss();
    });
    spinButton.addEventListener('click', spin);

    copyButton?.addEventListener('click', async () => {
      const code = codeNode.textContent.trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        return;
      }
      const original = copyButton.textContent;
      copyButton.textContent = copyButton.dataset.copiedLabel || original;
      window.setTimeout(() => {
        copyButton.textContent = original;
      }, 1800);
    });

    activateButton?.addEventListener('click', async () => {
      const code = codeNode.textContent.trim();
      if (!code) return;
      const original = activateButton.textContent;
      activateButton.disabled = true;
      activateButton.textContent = activateButton.dataset.busyLabel || original;
      try {
        await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: 'follow' });
        activateButton.textContent = activateButton.dataset.doneLabel || original;
        window.setTimeout(close, 1400);
      } catch (error) {
        activateButton.disabled = false;
        activateButton.textContent = original;
      }
    });

    if (BLOCKED_TEMPLATES.includes(dialog.dataset.template)) return;

    const state = readState();
    if (!designMode) {
      if (state.status === 'won') return;
      if (state.status === 'dismissed' && Date.now() < Number(state.until || 0)) return;
    }

    const tryOpen = (attempt = 0) => {
      if (document.querySelector('dialog[open]')) {
        if (attempt < 3) window.setTimeout(() => tryOpen(attempt + 1), 6000);
        return;
      }
      if (!claimSession()) return;
      open();
    };

    const timer = window.setTimeout(tryOpen, (Number(dialog.dataset.delay) || 12) * 1000);

    // Exit-Intent nur mit echtem Mauszeiger; auf Touch gibt es kein Verlassen nach oben.
    if (dialog.dataset.exitIntent === 'true' && window.matchMedia('(pointer: fine)').matches) {
      const onLeave = (event) => {
        if (event.clientY > 0 || dialog.open) return;
        document.removeEventListener('mouseout', onLeave);
        window.clearTimeout(timer);
        tryOpen();
      };
      document.addEventListener('mouseout', onLeave);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
